// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: "http://localhost" | (string & {});
};

export type SchoolFormConfirmationDto = {
    wantsToRegisterSchool?: boolean;
    amCititSiSuntDeAcord?: boolean;
};

export type AddressDto = {
    id?: string;
    judet: string;
    oras: string;
    comuna?: string;
    sat?: string;
    strada?: string;
    numar?: string;
    codPostal?: string;
    bloc?: string;
    scara?: string;
    etaj?: string;
    apartament?: string;
};

export type RangeLocalDateTime = {
    start?: Date;
    end?: Date;
};

export type SchoolRequestDto = {
    id?: string;
    numeInstitutieInvatamant: string;
    codSe?: string;
    cui: string;
    adresa: AddressDto;
    numeReprezentatLegal: string;
    telefon: string;
    numarElevi: number;
    detineRecipiente: boolean;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    adresaLivrareAceeasiCuScoala: boolean;
    adresaLivrare?: AddressDto;
    professorId?: string;
    companyId?: string;
    prinPrezentaConfirmamInscrierea?: boolean;
    amFostInformati?: boolean;
    confirmFaptulCaReprezentatulLegal?: boolean;
    prinPrezentaConfirmCaAmCititInformarea?: boolean;
    confirmCaInCazulInCareProiectul?: boolean;
    consimtPentruPastrareaDatelorPersonale?: boolean;
    codSeNumeric?: number;
    readonly videoVazutDt?: Date;
    editionId?: string;
    adminRejectReason?: string;
    timestamp?: Date;
    timestampRange?: RangeLocalDateTime;
    confirmCaAmAcordulDePrincipiu?: boolean;
    codSiiirUnitate: string;
    amCititSiSuntDeAcord?: boolean;
    ecoticPoateFolosiImagini?: boolean;
    acordGrupWhatsapp?: boolean;
    readonly acordGrupWhatsappDt?: Date;
    approvalStatus?: "PENDING" | "APPROVED" | "REJECTED";
};

export type WasteContainerRequestDto = {
    id?: string;
    fel: "RECIPIENT_DBA" | "MINIRECIPIENTE";
    cantitate?: number;
    contactPersonName: string;
    contactPersonPhone: string;
    deliveryAddress: AddressDto;
    stare?: "NOUA" | "PROCESATA" | "LIVRATA";
    procesataLaDt?: Date;
    livrataLaDt?: Date;
    timestamp?: Date;
    trimisLaDt?: Date;
};

export type WasteCollectionFormDto = {
    id?: string;
    schoolId?: string;
    pickupAddress: AddressDto;
    contactPersonName: string;
    contactPersonPhone: string;
    contactPersonEmail: string;
    isValidated?: boolean;
    deeeKg?: number;
    dbaKg?: number;
    becuriSiNeoaneKg?: number;
    rejectReason?: string;
    photos: Array<string>;
    isProcessed?: boolean;
    dataOrientativaColectare: Date;
    timestamp?: Date;
    consent?: boolean;
    realDeeeKg?: number;
    realDbaKg?: number;
    realBecuriSiNeoaneKg?: number;
    pickupAddressSameWithSchoolAddress: boolean;
    editionId?: string;
    userId?: string;
    validatedAt?: Date;
    processedAt?: Date;
    deeeOrderNumber?: string;
    dbaOrderNumber?: string;
    deeeOrderProcessedDate?: Date;
    dbaOrderProcessedDate?: Date;
    deeeOrderDocument?: string;
    dbaOrderDocument?: string;
};

export type TicketTierDto = {
    id?: string;
    editionId: string;
    level: number;
    name: string;
    pointsCost: number;
    couponValue: number;
    availableFrom?: Date;
    availableTo?: Date;
    maxPerSchool?: number;
    descriere?: string;
};

export type TicketRedemptionRequestDto = {
    tierId: string;
    alegereProfesor?: string;
};

export type TicketRedemptionDto = {
    id?: string;
    schoolId?: string;
    schoolName?: string;
    editionId?: string;
    tierId?: string;
    tierLevel?: number;
    tierName?: string;
    pointsSpent?: number;
    redeemedById?: string;
    redeemedByName?: string;
    redeemedDt?: Date;
    status?: "REQUESTED" | "CONFIRMED" | "FULFILLED" | "CANCELLED";
    alegereProfesor?: string;
    note?: string;
};

export type OptionDto = {
    id?: string;
    number?: number;
    text?: string;
    image?: string;
    correct: boolean;
};

export type SlideDto = {
    id?: string;
    type?: string;
    number?: number;
    text: string;
    image?: string;
    video?: string;
    videoStart?: number;
    videoEnd?: number;
    timeLimit?: number;
    options?: Array<OptionDto>;
    description?: string;
};

export type SchoolDto = {
    id?: string;
    numeInstitutieInvatamant: string;
    codSe?: string;
    cui: string;
    adresa: AddressDto;
    numeReprezentatLegal: string;
    telefon: string;
    numarElevi: number;
    detineRecipiente: boolean;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    adresaLivrareAceeasiCuScoala: boolean;
    adresaLivrare?: AddressDto;
    professorId?: string;
    companyId?: string;
    codSeNumeric?: number;
    codSiiirUnitate: string;
    updatedAt?: Date;
    prinPrezentaConfirmamInscrierea?: boolean;
    amFostInformati?: boolean;
    confirmFaptulCaReprezentatulLegal?: boolean;
    prinPrezentaConfirmCaAmCititInformarea?: boolean;
    confirmCaInCazulInCareProiectul?: boolean;
    consimtPentruPastrareaDatelorPersonale?: boolean;
    confirmCaAmAcordulDePrincipiu?: boolean;
    amCititSiSuntDeAcord?: boolean;
    ecoticPoateFolosiImagini?: boolean;
};

export type CreateCollaboratorLinkRequest = {
    label: string;
};

export type CollaboratorLinkDto = {
    id?: string;
    label?: string;
    url?: string;
    createdAt?: Date;
    revokedAt?: Date;
    lastUsedAt?: Date;
    active?: boolean;
};

export type RaportImportMec = {
    randuriCitite?: number;
    inSelectie?: number;
    noi?: number;
    actualizate?: number;
    absenteDinSelectie?: number;
    exempleAbsente?: Array<string>;
};

export type NotificationDto = {
    id?: string;
    subject: string;
    content: string;
    senderId?: string;
    receiverIds: Array<string>;
    sendAt?: Date;
    editionId?: string;
};

export type LessonDto = {
    id?: string;
    title: string;
    description: string;
    slides: Array<SlideDto>;
    companyId?: string;
    timestamp?: Date;
    type?: string;
    isHidden?: boolean;
    image?: string;
    pdfManualUrl?: string;
    areRaspunsuriPdf?: boolean;
    hasLastVersionFullyCompleted?: boolean;
    attemptState?: string;
    isSynced?: boolean;
    deadline?: Date;
    punctajMaxim?: bigint;
    depuneriInAsteptare?: number;
    depuneriAprobate?: number;
};

export type DepunereActivitateDto = {
    photoUrls?: Array<string>;
    clase?: string;
    description?: string;
};

export type FaqEntryDto = {
    id?: string;
    editionId?: string;
    keywords: string;
    answer: string;
    displayOrder?: number;
    active?: boolean;
};

/**
 * Rezultatul trimiterii unei scoli in ERP
 */
export type ErpSchoolResyncDto = {
    /**
     * Id-ul scolii cerute
     */
    schoolId?: string;
    /**
     * Codul SE al scolii
     */
    codSe?: string | null;
    /**
     * Ce s-a intamplat cu trimiterea
     */
    outcome?: "SYNCED" | "REFUSED" | "UNAVAILABLE" | "NO_PROFESSOR" | "NOT_FOUND";
    /**
     * Statusul HTTP intors de ERP, daca a raspuns
     */
    httpStatus?: number | null;
    /**
     * Corpul raspunsului ERP, taiat la 500 de caractere
     */
    erpMessage?: string | null;
};

export type EditionDto = {
    id?: string;
    nume: string;
    isCurrentEdition: boolean;
    maxScoredPracticalActivitiesPerSchool?: number;
    startDate?: Date;
    endDate?: Date;
};

export type CookieConsentCerere = {
    consentId: string;
    categorii: string;
    actiune: string;
    revizie: number;
};

export type CompanyDto = {
    id?: string;
    denumire?: string;
    cui?: string;
};

export type CollabActivitySubmissionDto = {
    lessonId: string;
    submittedByName: string;
    description?: string;
    photoUrls?: Array<string>;
    clase?: string;
    submittedByPrenume?: string;
    numarElevi?: number;
};

export type ErrorResponse = {
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;
    message?: string;
    errors?: {
        [key: string]: string;
    };
    fragmenteNerecunoscute?: Array<string>;
};

export type CodScoalaCerere = {
    codSe: string;
};

export type CodScoalaConfirmare = {
    schoolName?: string;
    editionName?: string;
};

export type CodScoalaSesiune = {
    token?: string;
};

export type RegisterRequest = {
    nume?: string;
    email: string;
    parola: string;
    role?: string;
    telefon?: string;
    codProfesor?: string;
    clasa?: string;
};

export type AuthenticationResponse = {
    token?: string;
    refreshToken?: string;
    expiresIn?: number;
};

/**
 * Cerere de reinscriere a unui elev din editia anterioara
 */
export type ReenrollRequest = {
    /**
     * Emailul folosit in editia anterioara
     */
    email: string;
    /**
     * Parola contului din editia anterioara
     */
    parola: string;
    /**
     * Clasa din editia curenta
     */
    clasa: string;
};

export type OtpVerifyRequest = {
    identificator: string;
    code: string;
};

/**
 * Motivul vizibil al refuzului unui cod
 */
export enum OtpEsecMotiv {
    COD_INVALID = "COD_INVALID",
    COD_EXPIRAT = "COD_EXPIRAT",
    COD_FOLOSIT = "COD_FOLOSIT",
}

/**
 * Raspunsul de esec al verificarii unui cod. `motiv` distinge doar codul expirat si codul deja folosit; orice alt esec e COD_INVALID.
 */
export type OtpEsecResponse = {
    message: string;
    motiv: OtpEsecMotiv;
};

export type OtpRequest = {
    identificator: string;
};

export type OtpInscriereRequest = {
    email?: string;
};

/**
 * De ce nu a plecat codul
 */
export enum OtpInscriereEsecMotiv {
    LIMITA_IP = "LIMITA_IP",
    LIMITA_COD = "LIMITA_COD",
    TRIMITERE_ESUATA = "TRIMITERE_ESUATA",
}

/**
 * Contul exista, dar codul nu a plecat: motivul si, la limita, cand se poate cere altul
 */
export type OtpInscriereEsecResponse = {
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;
    message?: string;
    errors?: {
        [key: string]: string;
    };
    fragmenteNerecunoscute?: Array<string>;
    motiv: OtpInscriereEsecMotiv;
    /**
     * Secunde pana cand se poate cere un cod nou; null la TRIMITERE_ESUATA
     */
    secundePanaLaCodNou?: number | null;
};

/**
 * Exista un cont pe adresa si, daca da, s-a cerut un cod de intrare
 */
export type OtpInscriereResponse = {
    areCont: boolean;
    codTrimis: boolean;
};

export type OtpInregistrareRequest = {
    nume: string;
    prenume: string;
    email: string;
    telefon?: string;
    rol?: string;
    codProfesor?: string;
    clasa?: string;
};

/**
 * Raspuns uniform: acelasi mesaj in toate cazurile
 */
export type OtpMesajResponse = {
    message?: string;
};

export type ResetPasswordRequest = {
    email: string;
};

/**
 * Cerere de schimb a unui token extern (Google etc.) pe un JWT propriu
 */
export type ExchangeRequest = {
    /**
     * Numele providerului extern, asa cum e configurat in auth.exchange.issuers.*
     */
    provider: string;
    /**
     * Tokenul emis de providerul extern (ex. ID token Google)
     */
    token: string;
};

export type AuthenticationRequest = {
    email: string;
    parola: string;
};

export type AnswerDto = {
    id?: string;
    userId?: string;
    slideId: string;
    lessonId?: string;
    photos?: Array<string>;
    selectedOptionsIds?: Array<string>;
    timestamp?: Date;
    version?: number;
    text?: string;
    editionId?: string;
    punctajFinal?: number;
    isLessonCompletedNow?: boolean;
    lessonType?:
        | "LESSON"
        | "HOMEWORK"
        | "PRACTICAL_ACTIVITY"
        | "DAILY_CHALLENGE"
        | "MONTHLY_CHALLENGE"
        | "CLASS_EXERCISE"
        | "SCHOOL_CHALLENGE";
    correctOptionsForResponse?: Array<string>;
    participants?: number;
    clase?: string;
    claseDejaPunctate?: Array<string>;
    lessonAnswerId?: string;
};

export type WasteContainerRequestEditDto = {
    cantitate?: number;
    contactPersonName?: string;
    contactPersonPhone?: string;
    deliveryAddress?: AddressDto;
};

export type WasteContainerRequestReportDto = {
    id?: string;
    schoolId?: string;
    schoolName?: string;
    codSe?: string;
    fel?: "RECIPIENT_DBA" | "MINIRECIPIENTE";
    cantitate?: number;
    contactPersonName?: string;
    contactPersonPhone?: string;
    deliveryAddress?: AddressDto;
    solicitantNume?: string;
    solicitantEmail?: string;
    timestamp?: Date;
    stare?: "NOUA" | "PROCESATA" | "LIVRATA";
    procesataLaDt?: Date;
    procesataDeNume?: string;
    livrataLaDt?: Date;
    livrataDeNume?: string;
};

export type ProfessorPhoneCallNoteDto = {
    phoneCallNote?: string;
};

export type UserDto = {
    id?: string;
    nume?: string;
    email?: string;
    isEnabled?: boolean;
    role?: "DBEST" | "ADMIN" | "PROFESOR" | "ELEV" | "LOGISTIC" | "SYNC";
    clasa?: string;
    telefon?: string;
    rejectReason?: string;
    hasSchoolRegistrationFormCompleted?: boolean;
    timestamp?: Date;
    lastLogin?: Date;
    timestampRange?: RangeLocalDateTime;
    schoolId?: string;
    companyId?: string;
    editionId?: string;
    phoneCallNote?: string;
    school?: SchoolDto;
    hasParentalApproval?: boolean;
    parentalApprovalSubmittedAt?: Date;
    emailVerifiedDt?: Date;
    editionNume?: string;
    toateEditiile?: boolean;
    ultimCodOtpDt?: Date;
    ultimCodOtp?: string;
};

export type UserSignatureDto = {
    signature: string;
    parentApproval?: boolean;
    prinPrezentaConfirmamInscriereaMinorului?: boolean;
    ecoticPoateFolosiImagini?: boolean;
    amFostInformati?: boolean;
    prinPrezentaConfirmCaAmCititInformarea?: boolean;
    confirmCaInCazulInCareProiectul?: boolean;
    consimtPentruPastrareaDatelorPersonale?: boolean;
    amCititSiSuntDeAcord?: boolean;
    userId?: string;
};

export type ParentalApprovalDto = {
    id?: string;
    userId?: string;
    studentName?: string;
    studentEmail?: string;
    signature?: string;
    parentApproval?: boolean;
    prinPrezentaConfirmamInscriereaMinorului?: boolean;
    ecoticPoateFolosiImagini?: boolean;
    amFostInformati?: boolean;
    prinPrezentaConfirmCaAmCititInformarea?: boolean;
    confirmCaInCazulInCareProiectul?: boolean;
    consimtPentruPastrareaDatelorPersonale?: boolean;
    amCititSiSuntDeAcord?: boolean;
    submittedAt?: Date;
    editionId?: string;
};

export type UserProfileDto = {
    id?: string;
    nume: string;
    email: string;
    isApproved?: boolean;
    hasSchoolRegistrationFormCompleted?: boolean;
    rejectReason?: string;
    codProfesor?: string;
    protocolDeColaborare?: Array<string>;
    protocolInEditiaCurenta?: boolean;
    points?: number;
    codSe?: string;
    clasa?: string;
    schoolUpdatedAt?: Date;
    school?: SchoolDto;
    parentalApproval?: ParentalApprovalDto;
    schoolRequest?: SchoolRequestDto;
    telefon?: string;
};

export type AdminUpdateUserDto = {
    userId: string;
    newEmail: string;
    phoneCallNote?: string;
};

export type TicketRedemptionStatusUpdateDto = {
    status: "REQUESTED" | "CONFIRMED" | "FULFILLED" | "CANCELLED";
    note?: string;
};

export type SchoolRequestReassignmentDto = {
    schoolRequestId?: string;
    newProfessorEmail?: string;
};

export type SchoolRequestApprovalDto = {
    schoolRequestId?: string;
    status: "PENDING" | "APPROVED" | "REJECTED";
    rejectReason?: string;
};

export type LessonAnswerDto = {
    id?: string;
    userId?: string;
    lessonId?: string;
    state?: string;
    isFirstCompletion?: boolean;
    startedAt?: Date;
    isApproved?: boolean;
    version?: number;
    timestamp?: Date;
    rejectReason?: string;
    points?: number;
    participants?: number;
    fiseValidate?: number;
    approvedAt?: Date;
};

export type ResetPasswordWithTokenDto = {
    newPassword: string;
    token: string;
};

export type ChangePasswordRequest = {
    currentPassword: string;
    newPassword: string;
};

export type Pageable = {
    page?: number;
    size?: number;
    sort?: Array<string>;
};

export type PageWasteContainerRequestReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<WasteContainerRequestReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageableObject = {
    offset?: bigint;
    sort?: SortObject;
    pageNumber?: number;
    pageSize?: number;
    unpaged?: boolean;
    paged?: boolean;
};

export type SortObject = {
    empty?: boolean;
    unsorted?: boolean;
    sorted?: boolean;
};

export type PeFel = {
    recipientDba?: bigint;
    minirecipiente?: bigint;
};

export type PeStare = {
    inAsteptare?: bigint;
    confirmata?: bigint;
    livrata?: bigint;
};

export type WasteContainerRequestContoareDto = {
    peStare?: PeStare;
    peFel?: PeFel;
    total?: bigint;
};

export type WasteCollectionFormReportDto = {
    id?: string;
    school?: SchoolDto;
    pickupAddress?: AddressDto;
    timestamp?: Date;
    deeeKg?: number;
    dbaKg?: number;
    becuriSiNeoaneKg?: number;
    contactPersonName?: string;
    contactPersonPhone?: string;
    contactPersonEmail?: string;
    timestampRange?: RangeLocalDateTime;
    photos?: Array<string>;
    rejectReason?: string;
    isValidated?: boolean;
    isProcessed?: boolean;
    dataOrientativaColectare?: Date;
    realDeeeKg?: number;
    realDbaKg?: number;
    realBecuriSiNeoaneKg?: number;
    pickupAddressSameWithSchoolAddress?: boolean;
    validatedAt?: Date;
    processedAt?: Date;
    editionId?: string;
    validatedAtRange?: RangeLocalDateTime;
    processedAtRange?: RangeLocalDateTime;
    dataOrientativaColectareRange?: RangeLocalDateTime;
    deeeOrderNumber?: string;
    dbaOrderNumber?: string;
    deeeOrderProcessedDate?: Date;
    dbaOrderProcessedDate?: Date;
    deeeOrderDocument?: string;
    dbaOrderDocument?: string;
    deeeOrderProcessedDateRange?: RangeLocalDateTime;
    dbaOrderProcessedDateRange?: RangeLocalDateTime;
};

export type PageWasteCollectionFormReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<WasteCollectionFormReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type PageProfesorReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<ProfesorReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type ProfesorReportDto = {
    userId?: string;
    nume?: string;
    email?: string;
    isEnabled?: boolean;
    rejectReason?: string;
    phoneCallNote?: string;
    telefon?: string;
    hasSchoolRegistrationFormCompleted?: boolean;
    timestampInregistrare?: Date;
    schoolRequestId?: string;
    numeInstitutieInvatamant?: string;
    codSe?: string;
    cui?: string;
    numeReprezentatLegal?: string;
    telefonInstitutie?: string;
    numarElevi?: number;
    detineRecipiente?: boolean;
    adresaLivrareAceeasiCuScoala?: boolean;
    codSeNumeric?: number;
    adminRejectReason?: string;
    timestampFormularInscriere?: Date;
    codSiiirUnitate?: string;
    approvalStatus?: string;
    editionId?: string;
    adresaId?: string;
    adresaJudet?: string;
    adresaOras?: string;
    adresaComuna?: string;
    adresaSat?: string;
    adresaStrada?: string;
    adresaNumar?: string;
    adresaCodPostal?: string;
    adresaBloc?: string;
    adresaScara?: string;
    adresaEtaj?: string;
    adresaApartament?: string;
    adresaLivrareId?: string;
    adresaLivrareJudet?: string;
    adresaLivrareOras?: string;
    adresaLivrareComuna?: string;
    adresaLivrareSat?: string;
    adresaLivrareStrada?: string;
    adresaLivrareNumar?: string;
    adresaLivrareCodPostal?: string;
    adresaLivrareBloc?: string;
    adresaLivrareScara?: string;
    adresaLivrareEtaj?: string;
    adresaLivrareApartament?: string;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    acordGrupWhatsapp?: boolean;
    acordGrupWhatsappDt?: Date;
    cererePreluare?: boolean;
    profesorActualNume?: string;
    profesorActualUltimaActivitate?: Date;
};

export type PageUserDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<UserDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type UserContactDto = {
    id?: string;
    role?: "DBEST" | "ADMIN" | "PROFESOR" | "ELEV" | "LOGISTIC" | "SYNC";
};

export type PageTicketRedemptionDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<TicketRedemptionDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type StudentLeaderboardRowDto = {
    editionId?: string;
    userId?: string;
    schoolId?: string;
    loc?: number;
    nume?: string;
    clasa?: string;
    scoala?: string;
    judet?: string;
    email?: string;
    telefon?: string;
    codProfesor?: string;
    puncteHomework?: bigint;
    puncteMonthly?: bigint;
    total?: bigint;
};

export type PageStudentLeaderboardRowDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<StudentLeaderboardRowDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type SchoolBalanceDto = {
    schoolId?: string;
    editionId?: string;
    earned?: number;
    spent?: number;
    available?: number;
};

export type EditionReportDto = {
    id?: string;
    numeInstitutieInvatamant?: string;
    codSe?: string;
    codSeNumeric?: number;
    cui?: string;
    codSiiirUnitate?: string;
    editionId?: string;
    totalDeeeKg?: number;
    totalDbaKg?: number;
    totalBecuriSiNeoaneKg?: number;
    totalKg?: number;
    pointsLesson?: bigint;
    pointsClassExercise?: bigint;
    pointsPracticalActivity?: bigint;
    pointsHomework?: bigint;
    pointsDailyChallenge?: bigint;
    pointsMonthlyChallenge?: bigint;
    countLesson?: bigint;
    countClassExercise?: bigint;
    countPracticalActivity?: bigint;
    countCollaboratorActivities?: bigint;
    countHomework?: bigint;
    countDailyChallenge?: bigint;
    countMonthlyChallenge?: bigint;
    pointsAllLessonsTotal?: bigint;
    pointsWasteCollectionTotal?: bigint;
    pointsGrandTotal?: bigint;
    mainJudet?: string;
    mainOras?: string;
    mainComuna?: string;
    mainSat?: string;
    mainStrada?: string;
    mainNumar?: string;
    mainCodPostal?: string;
    mainBloc?: string;
    mainScara?: string;
    mainEtaj?: string;
    mainApartament?: string;
    deliveryJudet?: string;
    deliveryOras?: string;
    deliveryComuna?: string;
    deliverySat?: string;
    deliveryStrada?: string;
    deliveryNumar?: string;
    deliveryCodPostal?: string;
    deliveryBloc?: string;
    deliveryScara?: string;
    deliveryEtaj?: string;
    deliveryApartament?: string;
    numeReprezentatLegal?: string;
    telefon?: string;
    professorNume?: string;
    professorEmail?: string;
    professorTelefon?: string;
    hasProtocol?: boolean;
    numarElevi?: number;
    detineRecipiente?: boolean;
    adresaLivrareAceeasiCuScoala?: boolean;
    updatedAt?: Date;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    pointsSchoolChallenge?: bigint;
    countSchoolChallenge?: bigint;
    stareProtocol?: string;
};

export type PageEditionReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<EditionReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type SchoolReportDto = {
    id?: string;
    numeInstitutieInvatamant?: string;
    codSe?: string;
    cui?: string;
    adresa?: AddressDto;
    numeReprezentatLegal?: string;
    telefon?: string;
    numarElevi?: number;
    detineRecipiente?: boolean;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    adresaLivrareAceeasiCuScoala?: boolean;
    adresaLivrare?: AddressDto;
    professor?: UserProfileDto;
    codSeNumeric?: number;
    editionId?: string;
    codSiiirUnitate?: string;
    updatedAt?: Date;
};

export type PageSchoolReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<SchoolReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

/**
 * Starea de inscriere a unei scoli in editia curenta
 */
export type SchoolRegistrationStatusDto = {
    /**
     * Starea scolii fata de editia curenta
     */
    status?: "LIBERA" | "APROBATA_EDITIA_CURENTA" | "IN_ASTEPTARE_EDITIA_CURENTA" | "EDITIE_ANTERIOARA";
    /**
     * Numele profesorului responsabil, daca exista. Fara email.
     */
    numeProfesor?: string | null;
};

export type SchoolDataImportDto = {
    id?: string;
    judet?: string;
    oras?: string;
    comuna?: string;
    sat?: string;
    strada?: string;
    numar?: string;
    telefon?: string;
    numeInstitutieInvatamant?: string;
    cui?: string;
    email?: string;
    codPostal?: string;
    codSireus?: string;
    codSiiirUnitate?: string;
    fax?: string;
    tipUnitate?: string;
    statut?: string;
    codSiiirPj?: string;
    cautare?: string;
};

export type PageSchoolDataImportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<SchoolDataImportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type SchoolDropdownDto = {
    id?: string;
    codSe?: string;
    schoolData?: string;
};

export type SchoolRequestReportDto = {
    id?: string;
    numeInstitutieInvatamant?: string;
    codSe?: string;
    cui?: string;
    adresa?: AddressDto;
    numeReprezentatLegal?: string;
    telefon?: string;
    numarElevi?: number;
    detineRecipiente?: boolean;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    adresaLivrareAceeasiCuScoala?: boolean;
    adresaLivrare?: AddressDto;
    codSeNumeric?: number;
    editionId?: string;
    adminRejectReason?: string;
    timestamp?: Date;
    timestampRange?: RangeLocalDateTime;
    codSiiirUnitate?: string;
    professor?: UserDto;
    approvalStatus?: "PENDING" | "APPROVED" | "REJECTED";
    schoolUpdatedAt?: Date;
    acordGrupWhatsapp?: boolean;
    acordGrupWhatsappDt?: Date;
    cererePreluare?: boolean;
    profesorActualUltimaActivitate?: Date;
    profesorActualNume?: string;
    cereriPeAceeasiScoala?: number;
    istoricProfesoriNumar?: number;
};

export type PageSchoolRequestReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<SchoolRequestReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type IstoricProfesorDto = {
    sursa?: "JURNAL" | "DIN_CERERI";
    tip?:
        | "PRIMA_INSCRIERE"
        | "PRELUARE"
        | "SCHIMBARE_ADMIN"
        | "SOLICITANT_SCHIMBAT"
        | "RENUNTARE"
        | "PLECARE_LA_ALTA_SCOALA";
    data?: Date;
    editieNume?: string;
    profesorAnteriorNume?: string;
    profesorAnteriorEmail?: string;
    profesorNouNume?: string;
    profesorNouEmail?: string;
    scoalaDestinatieNume?: string;
    facutDeNume?: string;
};

export type PageSchedulerRunDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<SchedulerRunDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type SchedulerRunDto = {
    id?: string;
    job?: string;
    startedAt?: Date;
    finishedAt?: Date;
    outcome?: string;
    detail?: string;
};

export type NotificationReadDto = {
    id?: string;
    receiverId?: string;
    receiverNume?: string;
    receiverEmail?: string;
    receiverRole?: "DBEST" | "ADMIN" | "PROFESOR" | "ELEV" | "LOGISTIC" | "SYNC";
    codSe?: string;
    numeInstitutieInvatamant?: string;
    isRead?: boolean;
    readAt?: Date;
};

export type NotificationReportDto = {
    id?: string;
    notification?: NotificationDto;
    receiver?: UserDto;
    isRead?: boolean;
    readAt?: Date;
    editionId?: string;
    readAtRange?: RangeLocalDateTime;
};

export type PageNotificationReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<NotificationReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type OutboxNotificationDto = {
    id?: string;
    subject?: string;
    content?: string;
    sendAt?: Date;
    status?: string;
};

export type PageOutboxNotificationDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<OutboxNotificationDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type InboxNotificationDto = {
    id?: string;
    subject?: string;
    content?: string;
    isRead?: boolean;
    readAt?: Date;
    sendAt?: Date;
};

export type PageInboxNotificationDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<InboxNotificationDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type LessonProgressDto = {
    id?: string;
    userId?: string;
    nume?: string;
    lessonId?: string;
    lessonTitle?: string;
    state?: string;
    isApproved?: boolean;
    timestamp?: Date;
    rejectReason?: string;
    school?: string;
};

export type CollaboratorLinkRefDto = {
    id?: string;
    label?: string;
};

export type LessonAnswerReportDto = {
    id?: string;
    lesson?: LessonDto;
    user?: UserDto;
    timestamp?: Date;
    rejectReason?: string;
    state?: string;
    isFirstCompletion?: boolean;
    startedAt?: Date;
    isApproved?: boolean;
    version?: number;
    points?: number;
    participants?: number;
    approvedAt?: Date;
    timestampRange?: RangeLocalDateTime;
    approvedAtRange?: RangeLocalDateTime;
    editionId?: string;
    submittedByName?: string;
    attemptNo?: number;
    scoringNote?: string;
    collaboratorLink?: CollaboratorLinkRefDto;
    primaPoza?: string;
    numarPoze?: number;
};

export type PageLessonAnswerReportDto = {
    totalPages?: number;
    totalElements?: bigint;
    size?: number;
    content?: Array<LessonAnswerReportDto>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    empty?: boolean;
};

export type OnboardingVideoDto = {
    bunVenitUrl?: string;
    litiuUrl?: string;
};

export type EditionDocumentsDto = {
    protocolColaborare?: string;
    regulament?: string;
    mecanism?: string;
    colaboratori?: string;
};

export type ActivityOption = {
    id?: string;
    title?: string;
    description?: string;
    image?: string;
    type?:
        | "LESSON"
        | "HOMEWORK"
        | "PRACTICAL_ACTIVITY"
        | "DAILY_CHALLENGE"
        | "MONTHLY_CHALLENGE"
        | "CLASS_EXERCISE"
        | "SCHOOL_CHALLENGE";
    deadline?: Date;
    arePdfExercitii?: boolean;
    areRaspunsuriPdf?: boolean;
    areVideo?: boolean;
};

export type CollabInfoDto = {
    schoolName?: string;
    editionName?: string;
    label?: string;
    activities?: Array<ActivityOption>;
};

export type BlobAnalysisResultDto = {
    totalBlobsInAzure?: bigint;
    totalReferencesInDatabase?: bigint;
    orphanedBlobsCount?: bigint;
    orphanedPercentage?: number;
    blobsByFolder?: {
        [key: string]: bigint;
    };
    orphanedBlobsByFolder?: {
        [key: string]: bigint;
    };
    orphanedBlobUrls?: Array<string>;
};

export type SchoolRequestDtoWritable = {
    id?: string;
    numeInstitutieInvatamant: string;
    codSe?: string;
    cui: string;
    adresa: AddressDto;
    numeReprezentatLegal: string;
    telefon: string;
    numarElevi: number;
    detineRecipiente: boolean;
    saptamanaVerdeStart?: Date;
    saptamanaVerdeEnd?: Date;
    adresaLivrareAceeasiCuScoala: boolean;
    adresaLivrare?: AddressDto;
    professorId?: string;
    companyId?: string;
    prinPrezentaConfirmamInscrierea?: boolean;
    amFostInformati?: boolean;
    confirmFaptulCaReprezentatulLegal?: boolean;
    prinPrezentaConfirmCaAmCititInformarea?: boolean;
    confirmCaInCazulInCareProiectul?: boolean;
    consimtPentruPastrareaDatelorPersonale?: boolean;
    codSeNumeric?: number;
    editionId?: string;
    adminRejectReason?: string;
    timestamp?: Date;
    timestampRange?: RangeLocalDateTime;
    confirmCaAmAcordulDePrincipiu?: boolean;
    codSiiirUnitate: string;
    amCititSiSuntDeAcord?: boolean;
    ecoticPoateFolosiImagini?: boolean;
    acordGrupWhatsapp?: boolean;
    approvalStatus?: "PENDING" | "APPROVED" | "REJECTED";
};

export type ConfirmSchoolRequestUpdateData = {
    body: SchoolFormConfirmationDto;
    path?: never;
    query?: never;
    url: "/api/school-requests/confirmation";
};

export type ConfirmSchoolRequestUpdateErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ConfirmSchoolRequestUpdateError = ConfirmSchoolRequestUpdateErrors[keyof ConfirmSchoolRequestUpdateErrors];

export type ConfirmSchoolRequestUpdateResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type ConfirmSchoolRequestUpdateResponse =
    ConfirmSchoolRequestUpdateResponses[keyof ConfirmSchoolRequestUpdateResponses];

export type CreateWasteContainerRequestData = {
    body: WasteContainerRequestDto;
    path?: never;
    query?: never;
    url: "/api/waste-container-requests";
};

export type CreateWasteContainerRequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateWasteContainerRequestError =
    CreateWasteContainerRequestErrors[keyof CreateWasteContainerRequestErrors];

export type CreateWasteContainerRequestResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: unknown;
    };
};

export type CreateWasteContainerRequestResponse =
    CreateWasteContainerRequestResponses[keyof CreateWasteContainerRequestResponses];

export type GetAllWasteCollectionFormsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/waste-collection-forms";
};

export type GetAllWasteCollectionFormsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllWasteCollectionFormsError = GetAllWasteCollectionFormsErrors[keyof GetAllWasteCollectionFormsErrors];

export type GetAllWasteCollectionFormsResponses = {
    /**
     * OK
     */
    200: Array<WasteCollectionFormDto>;
};

export type GetAllWasteCollectionFormsResponse =
    GetAllWasteCollectionFormsResponses[keyof GetAllWasteCollectionFormsResponses];

export type UpdateWasteCollectionFormData = {
    body: WasteCollectionFormDto;
    path?: never;
    query?: never;
    url: "/api/waste-collection-forms";
};

export type UpdateWasteCollectionFormErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateWasteCollectionFormError = UpdateWasteCollectionFormErrors[keyof UpdateWasteCollectionFormErrors];

export type UpdateWasteCollectionFormResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type UpdateWasteCollectionFormResponse =
    UpdateWasteCollectionFormResponses[keyof UpdateWasteCollectionFormResponses];

export type CreateWasteCollectionFormData = {
    body: WasteCollectionFormDto;
    path?: never;
    query?: never;
    url: "/api/waste-collection-forms";
};

export type CreateWasteCollectionFormErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateWasteCollectionFormError = CreateWasteCollectionFormErrors[keyof CreateWasteCollectionFormErrors];

export type CreateWasteCollectionFormResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type CreateWasteCollectionFormResponse =
    CreateWasteCollectionFormResponses[keyof CreateWasteCollectionFormResponses];

export type GetTicketTiersData = {
    body?: never;
    path?: never;
    query?: {
        editionId?: string;
    };
    url: "/api/ticket-tiers";
};

export type GetTicketTiersErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetTicketTiersError = GetTicketTiersErrors[keyof GetTicketTiersErrors];

export type GetTicketTiersResponses = {
    /**
     * OK
     */
    200: Array<TicketTierDto>;
};

export type GetTicketTiersResponse = GetTicketTiersResponses[keyof GetTicketTiersResponses];

export type UpdateTicketTierData = {
    body: TicketTierDto;
    path?: never;
    query?: never;
    url: "/api/ticket-tiers";
};

export type UpdateTicketTierErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateTicketTierError = UpdateTicketTierErrors[keyof UpdateTicketTierErrors];

export type UpdateTicketTierResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: unknown;
    };
};

export type UpdateTicketTierResponse = UpdateTicketTierResponses[keyof UpdateTicketTierResponses];

export type CreateTicketTierData = {
    body: TicketTierDto;
    path?: never;
    query?: never;
    url: "/api/ticket-tiers";
};

export type CreateTicketTierErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateTicketTierError = CreateTicketTierErrors[keyof CreateTicketTierErrors];

export type CreateTicketTierResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: unknown;
    };
};

export type CreateTicketTierResponse = CreateTicketTierResponses[keyof CreateTicketTierResponses];

export type GetTicketRedemptionsData = {
    body?: never;
    path?: never;
    query: {
        editionId?: string;
        status?: "REQUESTED" | "CONFIRMED" | "FULFILLED" | "CANCELLED";
        pageable: Pageable;
    };
    url: "/api/ticket-redemptions";
};

export type GetTicketRedemptionsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetTicketRedemptionsError = GetTicketRedemptionsErrors[keyof GetTicketRedemptionsErrors];

export type GetTicketRedemptionsResponses = {
    /**
     * OK
     */
    200: PageTicketRedemptionDto;
};

export type GetTicketRedemptionsResponse = GetTicketRedemptionsResponses[keyof GetTicketRedemptionsResponses];

export type RedeemTicketData = {
    body: TicketRedemptionRequestDto;
    path?: never;
    query?: never;
    url: "/api/ticket-redemptions";
};

export type RedeemTicketErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type RedeemTicketError = RedeemTicketErrors[keyof RedeemTicketErrors];

export type RedeemTicketResponses = {
    /**
     * OK
     */
    200: TicketRedemptionDto;
};

export type RedeemTicketResponse = RedeemTicketResponses[keyof RedeemTicketResponses];

export type GetAllSlidesData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/slides";
};

export type GetAllSlidesErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllSlidesError = GetAllSlidesErrors[keyof GetAllSlidesErrors];

export type GetAllSlidesResponses = {
    /**
     * OK
     */
    200: Array<SlideDto>;
};

export type GetAllSlidesResponse = GetAllSlidesResponses[keyof GetAllSlidesResponses];

export type UpdateSlideData = {
    body: SlideDto;
    path?: never;
    query?: never;
    url: "/api/slides";
};

export type UpdateSlideErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateSlideError = UpdateSlideErrors[keyof UpdateSlideErrors];

export type UpdateSlideResponses = {
    /**
     * OK
     */
    200: SlideDto;
};

export type UpdateSlideResponse = UpdateSlideResponses[keyof UpdateSlideResponses];

export type CreateSlideData = {
    body: SlideDto;
    path?: never;
    query?: never;
    url: "/api/slides";
};

export type CreateSlideErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateSlideError = CreateSlideErrors[keyof CreateSlideErrors];

export type CreateSlideResponses = {
    /**
     * OK
     */
    200: SlideDto;
};

export type CreateSlideResponse = CreateSlideResponses[keyof CreateSlideResponses];

export type GetAllSchoolsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools";
};

export type GetAllSchoolsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllSchoolsError = GetAllSchoolsErrors[keyof GetAllSchoolsErrors];

export type GetAllSchoolsResponses = {
    /**
     * OK
     */
    200: Array<SchoolDto>;
};

export type GetAllSchoolsResponse = GetAllSchoolsResponses[keyof GetAllSchoolsResponses];

export type UpdateSchoolData = {
    body: SchoolDto;
    path?: never;
    query?: never;
    url: "/api/schools";
};

export type UpdateSchoolErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateSchoolError = UpdateSchoolErrors[keyof UpdateSchoolErrors];

export type UpdateSchoolResponses = {
    /**
     * OK
     */
    200: SchoolDto;
};

export type UpdateSchoolResponse = UpdateSchoolResponses[keyof UpdateSchoolResponses];

export type CreateSchoolData = {
    body: SchoolDto;
    path?: never;
    query?: never;
    url: "/api/schools";
};

export type CreateSchoolErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateSchoolError = CreateSchoolErrors[keyof CreateSchoolErrors];

export type CreateSchoolResponses = {
    /**
     * OK
     */
    200: SchoolDto;
};

export type CreateSchoolResponse = CreateSchoolResponses[keyof CreateSchoolResponses];

export type ListCollaboratorLinksData = {
    body?: never;
    path: {
        schoolId: string;
    };
    query?: never;
    url: "/api/schools/{schoolId}/collaborator-links";
};

export type ListCollaboratorLinksErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ListCollaboratorLinksError = ListCollaboratorLinksErrors[keyof ListCollaboratorLinksErrors];

export type ListCollaboratorLinksResponses = {
    /**
     * OK
     */
    200: Array<CollaboratorLinkDto>;
};

export type ListCollaboratorLinksResponse = ListCollaboratorLinksResponses[keyof ListCollaboratorLinksResponses];

export type CreateCollaboratorLinkData = {
    body: CreateCollaboratorLinkRequest;
    path: {
        schoolId: string;
    };
    query?: never;
    url: "/api/schools/{schoolId}/collaborator-links";
};

export type CreateCollaboratorLinkErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateCollaboratorLinkError = CreateCollaboratorLinkErrors[keyof CreateCollaboratorLinkErrors];

export type CreateCollaboratorLinkResponses = {
    /**
     * OK
     */
    200: CollaboratorLinkDto;
};

export type CreateCollaboratorLinkResponse = CreateCollaboratorLinkResponses[keyof CreateCollaboratorLinkResponses];

export type ImportMecSchoolListData = {
    body?: {
        file: Blob | File;
    };
    path?: never;
    query?: {
        doarSelectia?: boolean;
    };
    url: "/api/schools/import-data/mec";
};

export type ImportMecSchoolListErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ImportMecSchoolListError = ImportMecSchoolListErrors[keyof ImportMecSchoolListErrors];

export type ImportMecSchoolListResponses = {
    /**
     * OK
     */
    200: RaportImportMec;
};

export type ImportMecSchoolListResponse = ImportMecSchoolListResponses[keyof ImportMecSchoolListResponses];

export type GetAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/school-requests";
};

export type GetAllErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllError = GetAllErrors[keyof GetAllErrors];

export type GetAllResponses = {
    /**
     * OK
     */
    200: Array<SchoolRequestDto>;
};

export type GetAllResponse = GetAllResponses[keyof GetAllResponses];

export type UpdateSchoolRequestData = {
    body: SchoolRequestDtoWritable;
    path?: never;
    query?: never;
    url: "/api/school-requests";
};

export type UpdateSchoolRequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateSchoolRequestError = UpdateSchoolRequestErrors[keyof UpdateSchoolRequestErrors];

export type UpdateSchoolRequestResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type UpdateSchoolRequestResponse = UpdateSchoolRequestResponses[keyof UpdateSchoolRequestResponses];

export type CreateSchoolRequestData = {
    body: SchoolRequestDtoWritable;
    path?: never;
    query?: never;
    url: "/api/school-requests";
};

export type CreateSchoolRequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateSchoolRequestError = CreateSchoolRequestErrors[keyof CreateSchoolRequestErrors];

export type CreateSchoolRequestResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type CreateSchoolRequestResponse = CreateSchoolRequestResponses[keyof CreateSchoolRequestResponses];

export type GetAllOptionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/options";
};

export type GetAllOptionsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllOptionsError = GetAllOptionsErrors[keyof GetAllOptionsErrors];

export type GetAllOptionsResponses = {
    /**
     * OK
     */
    200: Array<OptionDto>;
};

export type GetAllOptionsResponse = GetAllOptionsResponses[keyof GetAllOptionsResponses];

export type UpdateOptionData = {
    body: OptionDto;
    path?: never;
    query?: never;
    url: "/api/options";
};

export type UpdateOptionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateOptionError = UpdateOptionErrors[keyof UpdateOptionErrors];

export type UpdateOptionResponses = {
    /**
     * OK
     */
    200: OptionDto;
};

export type UpdateOptionResponse = UpdateOptionResponses[keyof UpdateOptionResponses];

export type CreateOptionData = {
    body: OptionDto;
    path?: never;
    query?: never;
    url: "/api/options";
};

export type CreateOptionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateOptionError = CreateOptionErrors[keyof CreateOptionErrors];

export type CreateOptionResponses = {
    /**
     * OK
     */
    200: OptionDto;
};

export type CreateOptionResponse = CreateOptionResponses[keyof CreateOptionResponses];

export type GetAllNotificationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/notifications";
};

export type GetAllNotificationsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllNotificationsError = GetAllNotificationsErrors[keyof GetAllNotificationsErrors];

export type GetAllNotificationsResponses = {
    /**
     * OK
     */
    200: Array<NotificationDto>;
};

export type GetAllNotificationsResponse = GetAllNotificationsResponses[keyof GetAllNotificationsResponses];

export type UpdateNotificationData = {
    body: NotificationDto;
    path?: never;
    query?: never;
    url: "/api/notifications";
};

export type UpdateNotificationErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateNotificationError = UpdateNotificationErrors[keyof UpdateNotificationErrors];

export type UpdateNotificationResponses = {
    /**
     * OK
     */
    200: NotificationDto;
};

export type UpdateNotificationResponse = UpdateNotificationResponses[keyof UpdateNotificationResponses];

export type CreateNotificationData = {
    body: NotificationDto;
    path?: never;
    query?: never;
    url: "/api/notifications";
};

export type CreateNotificationErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateNotificationError = CreateNotificationErrors[keyof CreateNotificationErrors];

export type CreateNotificationResponses = {
    /**
     * OK
     */
    200: NotificationDto;
};

export type CreateNotificationResponse = CreateNotificationResponses[keyof CreateNotificationResponses];

export type ResendNotificationData = {
    body?: never;
    path: {
        /**
         * Notification UUID identifier
         */
        id: string;
    };
    query?: never;
    url: "/api/notifications/{id}/resend";
};

export type ResendNotificationErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ResendNotificationError = ResendNotificationErrors[keyof ResendNotificationErrors];

export type ResendNotificationResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetAllLessonsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/lessons";
};

export type GetAllLessonsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllLessonsError = GetAllLessonsErrors[keyof GetAllLessonsErrors];

export type GetAllLessonsResponses = {
    /**
     * OK
     */
    200: Array<LessonDto>;
};

export type GetAllLessonsResponse = GetAllLessonsResponses[keyof GetAllLessonsResponses];

export type UpdateLessonData = {
    body: LessonDto;
    path?: never;
    query?: never;
    url: "/api/lessons";
};

export type UpdateLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateLessonError = UpdateLessonErrors[keyof UpdateLessonErrors];

export type UpdateLessonResponses = {
    /**
     * OK
     */
    200: LessonDto;
};

export type UpdateLessonResponse = UpdateLessonResponses[keyof UpdateLessonResponses];

export type CreateLessonData = {
    body: LessonDto;
    path?: never;
    query?: never;
    url: "/api/lessons";
};

export type CreateLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateLessonError = CreateLessonErrors[keyof CreateLessonErrors];

export type CreateLessonResponses = {
    /**
     * OK
     */
    200: LessonDto;
};

export type CreateLessonResponse = CreateLessonResponses[keyof CreateLessonResponses];

export type DepuneActivitatePracticaData = {
    body: DepunereActivitateDto;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/lessons/{id}/depunere-activitate";
};

export type DepuneActivitatePracticaErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DepuneActivitatePracticaError = DepuneActivitatePracticaErrors[keyof DepuneActivitatePracticaErrors];

export type DepuneActivitatePracticaResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: string;
    };
};

export type DepuneActivitatePracticaResponse =
    DepuneActivitatePracticaResponses[keyof DepuneActivitatePracticaResponses];

export type UploadImageData = {
    body?: {
        file: Blob | File;
    };
    path?: never;
    query?: {
        folder?: string;
    };
    url: "/api/files/upload";
};

export type UploadImageErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UploadImageError = UploadImageErrors[keyof UploadImageErrors];

export type UploadImageResponses = {
    /**
     * OK
     */
    200: string;
};

export type UploadImageResponse = UploadImageResponses[keyof UploadImageResponses];

export type GetAllFaqEntriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/faq";
};

export type GetAllFaqEntriesErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllFaqEntriesError = GetAllFaqEntriesErrors[keyof GetAllFaqEntriesErrors];

export type GetAllFaqEntriesResponses = {
    /**
     * OK
     */
    200: Array<FaqEntryDto>;
};

export type GetAllFaqEntriesResponse = GetAllFaqEntriesResponses[keyof GetAllFaqEntriesResponses];

export type UpdateFaqEntryData = {
    body: FaqEntryDto;
    path?: never;
    query?: never;
    url: "/api/faq";
};

export type UpdateFaqEntryErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateFaqEntryError = UpdateFaqEntryErrors[keyof UpdateFaqEntryErrors];

export type UpdateFaqEntryResponses = {
    /**
     * OK
     */
    200: FaqEntryDto;
};

export type UpdateFaqEntryResponse = UpdateFaqEntryResponses[keyof UpdateFaqEntryResponses];

export type CreateFaqEntryData = {
    body: FaqEntryDto;
    path?: never;
    query?: never;
    url: "/api/faq";
};

export type CreateFaqEntryErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateFaqEntryError = CreateFaqEntryErrors[keyof CreateFaqEntryErrors];

export type CreateFaqEntryResponses = {
    /**
     * OK
     */
    200: FaqEntryDto;
};

export type CreateFaqEntryResponse = CreateFaqEntryResponses[keyof CreateFaqEntryResponses];

export type ResyncSchoolToErpData = {
    body?: never;
    path: {
        schoolId: string;
    };
    query?: never;
    url: "/api/erp/schools/{schoolId}/resync";
};

export type ResyncSchoolToErpErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ResyncSchoolToErpError = ResyncSchoolToErpErrors[keyof ResyncSchoolToErpErrors];

export type ResyncSchoolToErpResponses = {
    /**
     * OK
     */
    200: ErpSchoolResyncDto;
};

export type ResyncSchoolToErpResponse = ResyncSchoolToErpResponses[keyof ResyncSchoolToErpResponses];

export type GetAllEditionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/editions";
};

export type GetAllEditionsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllEditionsError = GetAllEditionsErrors[keyof GetAllEditionsErrors];

export type GetAllEditionsResponses = {
    /**
     * OK
     */
    200: Array<EditionDto>;
};

export type GetAllEditionsResponse = GetAllEditionsResponses[keyof GetAllEditionsResponses];

export type UpdateEditionData = {
    body: EditionDto;
    path?: never;
    query?: never;
    url: "/api/editions";
};

export type UpdateEditionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateEditionError = UpdateEditionErrors[keyof UpdateEditionErrors];

export type UpdateEditionResponses = {
    /**
     * OK
     */
    200: EditionDto;
};

export type UpdateEditionResponse = UpdateEditionResponses[keyof UpdateEditionResponses];

export type CreateEditionData = {
    body: EditionDto;
    path?: never;
    query?: never;
    url: "/api/editions";
};

export type CreateEditionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateEditionError = CreateEditionErrors[keyof CreateEditionErrors];

export type CreateEditionResponses = {
    /**
     * OK
     */
    200: EditionDto;
};

export type CreateEditionResponse = CreateEditionResponses[keyof CreateEditionResponses];

export type SetCurrentEditionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/editions/{id}/set-current";
};

export type SetCurrentEditionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type SetCurrentEditionError = SetCurrentEditionErrors[keyof SetCurrentEditionErrors];

export type SetCurrentEditionResponses = {
    /**
     * OK
     */
    200: EditionDto;
};

export type SetCurrentEditionResponse = SetCurrentEditionResponses[keyof SetCurrentEditionResponses];

export type SendErrorMessageData = {
    body?: never;
    path?: never;
    query: {
        error: string;
    };
    url: "/api/discord-messages";
};

export type SendErrorMessageErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type SendErrorMessageError = SendErrorMessageErrors[keyof SendErrorMessageErrors];

export type SendErrorMessageResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type InregistreazaAcordCookieData = {
    body: CookieConsentCerere;
    path?: never;
    query?: never;
    url: "/api/cookie-consents";
};

export type InregistreazaAcordCookieErrors = {
    /**
     * Corp invalid
     */
    400: unknown;
    /**
     * Prea multe cereri
     */
    429: unknown;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type InregistreazaAcordCookieError = InregistreazaAcordCookieErrors[keyof InregistreazaAcordCookieErrors];

export type InregistreazaAcordCookieResponses = {
    /**
     * Alegerea a fost salvata
     */
    204: void;
};

export type InregistreazaAcordCookieResponse =
    InregistreazaAcordCookieResponses[keyof InregistreazaAcordCookieResponses];

export type GetAllCompaniesData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/companies";
};

export type GetAllCompaniesErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllCompaniesError = GetAllCompaniesErrors[keyof GetAllCompaniesErrors];

export type GetAllCompaniesResponses = {
    /**
     * OK
     */
    200: Array<CompanyDto>;
};

export type GetAllCompaniesResponse = GetAllCompaniesResponses[keyof GetAllCompaniesResponses];

export type UpdateCompanyData = {
    body: CompanyDto;
    path?: never;
    query?: never;
    url: "/api/companies";
};

export type UpdateCompanyErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateCompanyError = UpdateCompanyErrors[keyof UpdateCompanyErrors];

export type UpdateCompanyResponses = {
    /**
     * OK
     */
    200: CompanyDto;
};

export type UpdateCompanyResponse = UpdateCompanyResponses[keyof UpdateCompanyResponses];

export type CreateCompanyData = {
    body: CompanyDto;
    path?: never;
    query?: never;
    url: "/api/companies";
};

export type CreateCompanyErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateCompanyError = CreateCompanyErrors[keyof CreateCompanyErrors];

export type CreateCompanyResponses = {
    /**
     * OK
     */
    200: CompanyDto;
};

export type CreateCompanyResponse = CreateCompanyResponses[keyof CreateCompanyResponses];

export type UploadCollabPhotoData = {
    body?: {
        file: Blob | File;
    };
    path: {
        token: string;
    };
    query?: never;
    url: "/api/collab/{token}/files";
};

export type UploadCollabPhotoErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UploadCollabPhotoError = UploadCollabPhotoErrors[keyof UploadCollabPhotoErrors];

export type UploadCollabPhotoResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: string;
    };
};

export type UploadCollabPhotoResponse = UploadCollabPhotoResponses[keyof UploadCollabPhotoResponses];

export type SubmitCollabActivityData = {
    body: CollabActivitySubmissionDto;
    path: {
        token: string;
    };
    query?: never;
    url: "/api/collab/{token}/activities";
};

export type SubmitCollabActivityErrors = {
    /**
     * Clase neintelese: `fragmenteNerecunoscute` le enumera
     */
    400: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type SubmitCollabActivityError = SubmitCollabActivityErrors[keyof SubmitCollabActivityErrors];

export type SubmitCollabActivityResponses = {
    /**
     * Depunere inregistrata
     */
    201: {
        [key: string]: string;
    };
};

export type SubmitCollabActivityResponse = SubmitCollabActivityResponses[keyof SubmitCollabActivityResponses];

export type ConfirmaCodScoalaData = {
    body: CodScoalaCerere;
    path?: never;
    query?: never;
    url: "/api/collab/cod";
};

export type ConfirmaCodScoalaErrors = {
    /**
     * Refuz uniform — cauza nu se poate deosebi
     */
    404: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ConfirmaCodScoalaError = ConfirmaCodScoalaErrors[keyof ConfirmaCodScoalaErrors];

export type ConfirmaCodScoalaResponses = {
    /**
     * Codul corespunde unei scoli inscrise in editia curenta
     */
    200: CodScoalaConfirmare;
};

export type ConfirmaCodScoalaResponse = ConfirmaCodScoalaResponses[keyof ConfirmaCodScoalaResponses];

export type DeschideSesiuneCodScoalaData = {
    body: CodScoalaCerere;
    path?: never;
    query?: never;
    url: "/api/collab/cod/sesiune";
};

export type DeschideSesiuneCodScoalaErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeschideSesiuneCodScoalaError = DeschideSesiuneCodScoalaErrors[keyof DeschideSesiuneCodScoalaErrors];

export type DeschideSesiuneCodScoalaResponses = {
    /**
     * OK
     */
    200: CodScoalaSesiune;
};

export type DeschideSesiuneCodScoalaResponse =
    DeschideSesiuneCodScoalaResponses[keyof DeschideSesiuneCodScoalaResponses];

export type RegisterData = {
    body: RegisterRequest;
    path?: never;
    query?: never;
    url: "/api/auth/register";
};

export type RegisterErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type RegisterError = RegisterErrors[keyof RegisterErrors];

export type RegisterResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type RegisterResponse = RegisterResponses[keyof RegisterResponses];

export type RefreshTokenData = {
    body: {
        [key: string]: string;
    };
    path?: never;
    query?: never;
    url: "/api/auth/refresh-token";
};

export type RefreshTokenErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type RefreshTokenError = RefreshTokenErrors[keyof RefreshTokenErrors];

export type RefreshTokenResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type RefreshTokenResponse = RefreshTokenResponses[keyof RefreshTokenResponses];

export type ReenrollData = {
    body: ReenrollRequest;
    path?: never;
    query?: never;
    url: "/api/auth/reenroll";
};

export type ReenrollErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ReenrollError = ReenrollErrors[keyof ReenrollErrors];

export type ReenrollResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type ReenrollResponse = ReenrollResponses[keyof ReenrollResponses];

export type VerifyData = {
    body: OtpVerifyRequest;
    path?: never;
    query?: never;
    url: "/api/auth/otp/verify";
};

export type VerifyErrors = {
    /**
     * Orice esec. motiv=COD_EXPIRAT / COD_FOLOSIT doar cand codul trimis a fost emis pentru acest cont; altfel COD_INVALID, cu acelasi mesaj uniform
     */
    400: OtpEsecResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type VerifyError = VerifyErrors[keyof VerifyErrors];

export type VerifyResponses = {
    /**
     * Cod corect: sesiune, ca la /api/auth/login
     */
    200: AuthenticationResponse;
};

export type VerifyResponse = VerifyResponses[keyof VerifyResponses];

export type RequestData = {
    body: OtpRequest;
    path?: never;
    query?: never;
    url: "/api/auth/otp/request";
};

export type RequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type RequestError = RequestErrors[keyof RequestErrors];

export type RequestResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: string;
    };
};

export type RequestResponse = RequestResponses[keyof RequestResponses];

export type OtpInscriereData = {
    body: OtpInscriereRequest;
    path?: never;
    query?: never;
    url: "/api/auth/otp/inscriere";
};

export type OtpInscriereErrors = {
    /**
     * Email lipsa sau fara forma de email
     */
    400: ErrorResponse;
    /**
     * motiv=LIMITA_IP: prea multe verificari de pe aceeasi adresa IP. motiv=LIMITA_COD: contul exista, dar a primit deja numarul maxim de coduri; secundePanaLaCodNou (= Retry-After) spune cand se poate cere altul, iar codurile deja primite raman valabile
     */
    429: OtpInscriereEsecResponse;
    /**
     * motiv=TRIMITERE_ESUATA: contul exista, dar codul nu a putut fi trimis (furnizorul de email / WhatsApp a refuzat mesajul)
     */
    503: OtpInscriereEsecResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type OtpInscriereError = OtpInscriereErrors[keyof OtpInscriereErrors];

export type OtpInscriereResponses = {
    /**
     * areCont / codTrimis
     */
    200: OtpInscriereResponse;
};

export type OtpInscriereResponse2 = OtpInscriereResponses[keyof OtpInscriereResponses];

export type OtpInregistrareData = {
    body: OtpInregistrareRequest;
    path?: never;
    query?: never;
    url: "/api/auth/otp/inregistrare";
};

export type OtpInregistrareErrors = {
    /**
     * Corp invalid: camp lipsa, email fara forma de email, telefon care nu e mobil romanesc
     */
    400: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type OtpInregistrareError = OtpInregistrareErrors[keyof OtpInregistrareErrors];

export type OtpInregistrareResponses = {
    /**
     * Acelasi corp in toate cazurile
     */
    200: OtpMesajResponse;
};

export type OtpInregistrareResponse = OtpInregistrareResponses[keyof OtpInregistrareResponses];

export type LogoutData = {
    body: {
        [key: string]: string;
    };
    path?: never;
    query?: never;
    url: "/api/auth/logout";
};

export type LogoutErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type LogoutError = LogoutErrors[keyof LogoutErrors];

export type LogoutResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type ForgotPasswordData = {
    body: ResetPasswordRequest;
    path?: never;
    query?: never;
    url: "/api/auth/forgot-password";
};

export type ForgotPasswordErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ForgotPasswordError = ForgotPasswordErrors[keyof ForgotPasswordErrors];

export type ForgotPasswordResponses = {
    /**
     * OK
     */
    200: string;
};

export type ForgotPasswordResponse = ForgotPasswordResponses[keyof ForgotPasswordResponses];

export type ExchangeData = {
    body: ExchangeRequest;
    path?: never;
    query?: never;
    url: "/api/auth/exchange";
};

export type ExchangeErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ExchangeError = ExchangeErrors[keyof ExchangeErrors];

export type ExchangeResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type ExchangeResponse = ExchangeResponses[keyof ExchangeResponses];

export type AuthenticateData = {
    body: AuthenticationRequest;
    path?: never;
    query?: never;
    url: "/api/auth/authenticate";
};

export type AuthenticateErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type AuthenticateError = AuthenticateErrors[keyof AuthenticateErrors];

export type AuthenticateResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type AuthenticateResponse = AuthenticateResponses[keyof AuthenticateResponses];

export type GetAllAnswersData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/answers";
};

export type GetAllAnswersErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllAnswersError = GetAllAnswersErrors[keyof GetAllAnswersErrors];

export type GetAllAnswersResponses = {
    /**
     * OK
     */
    200: Array<AnswerDto>;
};

export type GetAllAnswersResponse = GetAllAnswersResponses[keyof GetAllAnswersResponses];

export type UpdateAnswerData = {
    body: AnswerDto;
    path?: never;
    query?: never;
    url: "/api/answers";
};

export type UpdateAnswerErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateAnswerError = UpdateAnswerErrors[keyof UpdateAnswerErrors];

export type UpdateAnswerResponses = {
    /**
     * OK
     */
    200: AnswerDto;
};

export type UpdateAnswerResponse = UpdateAnswerResponses[keyof UpdateAnswerResponses];

export type CreateAnswerData = {
    body: AnswerDto;
    path?: never;
    query?: never;
    url: "/api/answers";
};

export type CreateAnswerErrors = {
    /**
     * Clase neintelese: `fragmenteNerecunoscute` le enumera
     */
    400: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type CreateAnswerError = CreateAnswerErrors[keyof CreateAnswerErrors];

export type CreateAnswerResponses = {
    /**
     * Raspuns salvat
     */
    201: AnswerDto;
};

export type CreateAnswerResponse = CreateAnswerResponses[keyof CreateAnswerResponses];

export type EditWasteContainerRequestData = {
    body: WasteContainerRequestEditDto;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/waste-container-requests/{id}";
};

export type EditWasteContainerRequestErrors = {
    /**
     * Cantitate pe recipientul DBA, sau camp invalid
     */
    400: ErrorResponse;
    /**
     * Id inexistent, fara corp
     */
    404: unknown;
    /**
     * Cererea nu mai e NOUA
     */
    409: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type EditWasteContainerRequestError = EditWasteContainerRequestErrors[keyof EditWasteContainerRequestErrors];

export type EditWasteContainerRequestResponses = {
    /**
     * Starea curenta, si la a doua apasare
     */
    200: WasteContainerRequestReportDto;
};

export type EditWasteContainerRequestResponse =
    EditWasteContainerRequestResponses[keyof EditWasteContainerRequestResponses];

export type MarkWasteContainerRequestProcessedData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/waste-container-requests/{id}/procesata";
};

export type MarkWasteContainerRequestProcessedErrors = {
    /**
     * Id inexistent, fara corp
     */
    404: unknown;
    /**
     * Cererea e deja LIVRATA
     */
    409: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type MarkWasteContainerRequestProcessedError =
    MarkWasteContainerRequestProcessedErrors[keyof MarkWasteContainerRequestProcessedErrors];

export type MarkWasteContainerRequestProcessedResponses = {
    /**
     * Starea curenta, si la a doua apasare
     */
    200: WasteContainerRequestReportDto;
};

export type MarkWasteContainerRequestProcessedResponse =
    MarkWasteContainerRequestProcessedResponses[keyof MarkWasteContainerRequestProcessedResponses];

export type MarkWasteContainerRequestDeliveredData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/waste-container-requests/{id}/livrata";
};

export type MarkWasteContainerRequestDeliveredErrors = {
    /**
     * Id inexistent, fara corp
     */
    404: unknown;
    /**
     * Tranzitie sarita: cererea nu e inca PROCESATA
     */
    409: ErrorResponse;
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type MarkWasteContainerRequestDeliveredError =
    MarkWasteContainerRequestDeliveredErrors[keyof MarkWasteContainerRequestDeliveredErrors];

export type MarkWasteContainerRequestDeliveredResponses = {
    /**
     * Starea curenta, si la a doua apasare
     */
    200: WasteContainerRequestReportDto;
};

export type MarkWasteContainerRequestDeliveredResponse =
    MarkWasteContainerRequestDeliveredResponses[keyof MarkWasteContainerRequestDeliveredResponses];

export type UpdateWasteCollectionFormRealValuesData = {
    body?: never;
    path: {
        /**
         * Waste collection form UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Actual DEEE weight in kg
         */
        realDeeeKg: number;
        /**
         * Actual DBA (batteries) weight in kg
         */
        realDbaKg: number;
        /**
         * Actual bulbs and neon weight in kg
         */
        realBecuriSiNeoaneKg: number;
    };
    url: "/api/waste-collection-forms/{id}/waste-real-values";
};

export type UpdateWasteCollectionFormRealValuesErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateWasteCollectionFormRealValuesError =
    UpdateWasteCollectionFormRealValuesErrors[keyof UpdateWasteCollectionFormRealValuesErrors];

export type UpdateWasteCollectionFormRealValuesResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type UpdateWasteCollectionFormRealValuesResponse =
    UpdateWasteCollectionFormRealValuesResponses[keyof UpdateWasteCollectionFormRealValuesResponses];

export type ValidateWasteCollectionFormData = {
    body?: never;
    path: {
        /**
         * Waste collection form UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Validation status (true to approve, false to reject)
         */
        isValidated: boolean;
        /**
         * Reason for rejection if not approved
         */
        rejectReason?: string;
    };
    url: "/api/waste-collection-forms/{id}/validation";
};

export type ValidateWasteCollectionFormErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ValidateWasteCollectionFormError =
    ValidateWasteCollectionFormErrors[keyof ValidateWasteCollectionFormErrors];

export type ValidateWasteCollectionFormResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type ValidateWasteCollectionFormResponse =
    ValidateWasteCollectionFormResponses[keyof ValidateWasteCollectionFormResponses];

export type ProcessWasteCollectionFormData = {
    body?: never;
    path: {
        /**
         * Waste collection form UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Processing status
         */
        isProcessed: boolean;
    };
    url: "/api/waste-collection-forms/{id}/process";
};

export type ProcessWasteCollectionFormErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ProcessWasteCollectionFormError = ProcessWasteCollectionFormErrors[keyof ProcessWasteCollectionFormErrors];

export type ProcessWasteCollectionFormResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type ProcessWasteCollectionFormResponse =
    ProcessWasteCollectionFormResponses[keyof ProcessWasteCollectionFormResponses];

export type UpdateWasteCollectionFormByAdminData = {
    body: WasteCollectionFormDto;
    path?: never;
    query?: never;
    url: "/api/waste-collection-forms/admin-update";
};

export type UpdateWasteCollectionFormByAdminErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateWasteCollectionFormByAdminError =
    UpdateWasteCollectionFormByAdminErrors[keyof UpdateWasteCollectionFormByAdminErrors];

export type UpdateWasteCollectionFormByAdminResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type UpdateWasteCollectionFormByAdminResponse =
    UpdateWasteCollectionFormByAdminResponses[keyof UpdateWasteCollectionFormByAdminResponses];

export type SetPhoneCallNoteData = {
    body: ProfessorPhoneCallNoteDto;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/users/{id}/phone-call-note";
};

export type SetPhoneCallNoteErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type SetPhoneCallNoteError = SetPhoneCallNoteErrors[keyof SetPhoneCallNoteErrors];

export type SetPhoneCallNoteResponses = {
    /**
     * OK
     */
    200: ProfessorPhoneCallNoteDto;
};

export type SetPhoneCallNoteResponse = SetPhoneCallNoteResponses[keyof SetPhoneCallNoteResponses];

export type ActivateUserData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        activat: boolean;
        rejectReason?: string;
    };
    url: "/api/users/{id}/activation";
};

export type ActivateUserErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ActivateUserError = ActivateUserErrors[keyof ActivateUserErrors];

export type ActivateUserResponses = {
    /**
     * OK
     */
    200: UserDto;
};

export type ActivateUserResponse = ActivateUserResponses[keyof ActivateUserResponses];

export type UpdateUserActivationData = {
    body: UserDto;
    path?: never;
    query?: never;
    url: "/api/users/update-activation";
};

export type UpdateUserActivationErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateUserActivationError = UpdateUserActivationErrors[keyof UpdateUserActivationErrors];

export type UpdateUserActivationResponses = {
    /**
     * OK
     */
    200: UserDto;
};

export type UpdateUserActivationResponse = UpdateUserActivationResponses[keyof UpdateUserActivationResponses];

export type UpdateUserSignatureData = {
    body: UserSignatureDto;
    path?: never;
    query?: never;
    url: "/api/users/signature";
};

export type UpdateUserSignatureErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateUserSignatureError = UpdateUserSignatureErrors[keyof UpdateUserSignatureErrors];

export type UpdateUserSignatureResponses = {
    /**
     * OK
     */
    200: UserProfileDto;
};

export type UpdateUserSignatureResponse = UpdateUserSignatureResponses[keyof UpdateUserSignatureResponses];

export type GetUserProfileData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * User UUID (requires ADMIN/DBEST role)
         */
        userId?: string;
        /**
         * Edition UUID for edition-specific data
         */
        editionId?: string;
    };
    url: "/api/users/profile";
};

export type GetUserProfileErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetUserProfileError = GetUserProfileErrors[keyof GetUserProfileErrors];

export type GetUserProfileResponses = {
    /**
     * OK
     */
    200: UserProfileDto;
};

export type GetUserProfileResponse = GetUserProfileResponses[keyof GetUserProfileResponses];

export type UpdateUserProfileData = {
    body: UserProfileDto;
    path?: never;
    query?: never;
    url: "/api/users/profile";
};

export type UpdateUserProfileErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateUserProfileError = UpdateUserProfileErrors[keyof UpdateUserProfileErrors];

export type UpdateUserProfileResponses = {
    /**
     * OK
     */
    200: UserProfileDto;
};

export type UpdateUserProfileResponse = UpdateUserProfileResponses[keyof UpdateUserProfileResponses];

export type UpdateUserByAdminData = {
    body: AdminUpdateUserDto;
    path?: never;
    query?: never;
    url: "/api/users/admin-update";
};

export type UpdateUserByAdminErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateUserByAdminError = UpdateUserByAdminErrors[keyof UpdateUserByAdminErrors];

export type UpdateUserByAdminResponses = {
    /**
     * OK
     */
    200: UserDto;
};

export type UpdateUserByAdminResponse = UpdateUserByAdminResponses[keyof UpdateUserByAdminResponses];

export type UpdateTicketRedemptionStatusData = {
    body: TicketRedemptionStatusUpdateDto;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/ticket-redemptions/{id}/status";
};

export type UpdateTicketRedemptionStatusErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateTicketRedemptionStatusError =
    UpdateTicketRedemptionStatusErrors[keyof UpdateTicketRedemptionStatusErrors];

export type UpdateTicketRedemptionStatusResponses = {
    /**
     * OK
     */
    200: TicketRedemptionDto;
};

export type UpdateTicketRedemptionStatusResponse =
    UpdateTicketRedemptionStatusResponses[keyof UpdateTicketRedemptionStatusResponses];

export type ReassignSchoolRequestToProfessorData = {
    body: SchoolRequestReassignmentDto;
    path?: never;
    query?: never;
    url: "/api/school-requests/reassign-professor";
};

export type ReassignSchoolRequestToProfessorErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ReassignSchoolRequestToProfessorError =
    ReassignSchoolRequestToProfessorErrors[keyof ReassignSchoolRequestToProfessorErrors];

export type ReassignSchoolRequestToProfessorResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type ReassignSchoolRequestToProfessorResponse =
    ReassignSchoolRequestToProfessorResponses[keyof ReassignSchoolRequestToProfessorResponses];

export type MarkOwnSchoolRequestVideoSeenData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/school-requests/own/video";
};

export type MarkOwnSchoolRequestVideoSeenErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type MarkOwnSchoolRequestVideoSeenError =
    MarkOwnSchoolRequestVideoSeenErrors[keyof MarkOwnSchoolRequestVideoSeenErrors];

export type MarkOwnSchoolRequestVideoSeenResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type MarkOwnSchoolRequestVideoSeenResponse =
    MarkOwnSchoolRequestVideoSeenResponses[keyof MarkOwnSchoolRequestVideoSeenResponses];

export type UpdateSchoolRequestApprovalStatusData = {
    body: SchoolRequestApprovalDto;
    path?: never;
    query?: never;
    url: "/api/school-requests/approval-status";
};

export type UpdateSchoolRequestApprovalStatusErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateSchoolRequestApprovalStatusError =
    UpdateSchoolRequestApprovalStatusErrors[keyof UpdateSchoolRequestApprovalStatusErrors];

export type UpdateSchoolRequestApprovalStatusResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type UpdateSchoolRequestApprovalStatusResponse =
    UpdateSchoolRequestApprovalStatusResponses[keyof UpdateSchoolRequestApprovalStatusResponses];

export type UpdateSchoolRequestByAdminData = {
    body: SchoolRequestDtoWritable;
    path?: never;
    query?: never;
    url: "/api/school-requests/admin-update";
};

export type UpdateSchoolRequestByAdminErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateSchoolRequestByAdminError = UpdateSchoolRequestByAdminErrors[keyof UpdateSchoolRequestByAdminErrors];

export type UpdateSchoolRequestByAdminResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type UpdateSchoolRequestByAdminResponse =
    UpdateSchoolRequestByAdminResponses[keyof UpdateSchoolRequestByAdminResponses];

export type MarkNotificationAsReadData = {
    body?: never;
    path: {
        /**
         * Notification UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Read status (true to mark as read, false to mark as unread)
         */
        isRead: boolean;
    };
    url: "/api/notifications/{id}/read";
};

export type MarkNotificationAsReadErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type MarkNotificationAsReadError = MarkNotificationAsReadErrors[keyof MarkNotificationAsReadErrors];

export type MarkNotificationAsReadResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type HideLessonData = {
    body?: never;
    path: {
        /**
         * Lesson UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Whether to hide the lesson
         */
        isHidden: boolean;
    };
    url: "/api/lessons/{id}/hide";
};

export type HideLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type HideLessonError = HideLessonErrors[keyof HideLessonErrors];

export type HideLessonResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type UpdateParticipantsData = {
    body?: never;
    path: {
        /**
         * Lesson answer UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Number of participants (must be >= 1)
         */
        participants: number;
    };
    url: "/api/lessons/answers/{id}/participants";
};

export type UpdateParticipantsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type UpdateParticipantsError = UpdateParticipantsErrors[keyof UpdateParticipantsErrors];

export type UpdateParticipantsResponses = {
    /**
     * OK
     */
    200: LessonAnswerDto;
};

export type UpdateParticipantsResponse = UpdateParticipantsResponses[keyof UpdateParticipantsResponses];

export type ConfirmLessonData = {
    body?: never;
    path: {
        /**
         * Lesson answer UUID identifier
         */
        id: string;
    };
    query: {
        /**
         * Approval status (true = approve, false = reject)
         */
        isApproved: boolean;
        /**
         * Reason for rejection (required when isApproved=false)
         */
        rejectReason?: string;
        /**
         * Points to award (required for CLASS_EXERCISE when isApproved=true, must be >= 0)
         */
        points?: number;
        /**
         * CLASS_EXERCISE only: validated worksheets counted on the photos (>= 0). Points = 8 x fise. Mutually exclusive with `points`.
         */
        fise?: number;
    };
    url: "/api/lessons/answers/{id}/approval";
};

export type ConfirmLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ConfirmLessonError = ConfirmLessonErrors[keyof ConfirmLessonErrors];

export type ConfirmLessonResponses = {
    /**
     * OK
     */
    200: LessonAnswerDto;
};

export type ConfirmLessonResponse = ConfirmLessonResponses[keyof ConfirmLessonResponses];

export type ResetPasswordData = {
    body: ResetPasswordWithTokenDto;
    path?: never;
    query?: never;
    url: "/api/auth/reset-password";
};

export type ResetPasswordErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ResetPasswordError = ResetPasswordErrors[keyof ResetPasswordErrors];

export type ResetPasswordResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type ResetPasswordResponse = ResetPasswordResponses[keyof ResetPasswordResponses];

export type ChangePasswordData = {
    body: ChangePasswordRequest;
    path?: never;
    query?: never;
    url: "/api/auth/change-password";
};

export type ChangePasswordErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ChangePasswordError = ChangePasswordErrors[keyof ChangePasswordErrors];

export type ChangePasswordResponses = {
    /**
     * OK
     */
    200: AuthenticationResponse;
};

export type ChangePasswordResponse = ChangePasswordResponses[keyof ChangePasswordResponses];

export type GetWasteContainerRequestsReportData = {
    body?: never;
    path?: never;
    query: {
        editionId?: string;
        stareRand?: "IN_ASTEPTARE" | "CONFIRMATA" | "LIVRATA";
        fel?: "RECIPIENT_DBA" | "MINIRECIPIENTE";
        cautare?: string;
        pageable: Pageable;
    };
    url: "/api/waste-container-requests/report";
};

export type GetWasteContainerRequestsReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetWasteContainerRequestsReportError =
    GetWasteContainerRequestsReportErrors[keyof GetWasteContainerRequestsReportErrors];

export type GetWasteContainerRequestsReportResponses = {
    /**
     * OK
     */
    200: PageWasteContainerRequestReportDto;
};

export type GetWasteContainerRequestsReportResponse =
    GetWasteContainerRequestsReportResponses[keyof GetWasteContainerRequestsReportResponses];

export type GetWasteContainerRequestsReportCountersData = {
    body?: never;
    path?: never;
    query?: {
        editionId?: string;
    };
    url: "/api/waste-container-requests/report/contoare";
};

export type GetWasteContainerRequestsReportCountersErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetWasteContainerRequestsReportCountersError =
    GetWasteContainerRequestsReportCountersErrors[keyof GetWasteContainerRequestsReportCountersErrors];

export type GetWasteContainerRequestsReportCountersResponses = {
    /**
     * OK
     */
    200: WasteContainerRequestContoareDto;
};

export type GetWasteContainerRequestsReportCountersResponse =
    GetWasteContainerRequestsReportCountersResponses[keyof GetWasteContainerRequestsReportCountersResponses];

export type GetOwnWasteContainerRequestsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/waste-container-requests/own";
};

export type GetOwnWasteContainerRequestsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOwnWasteContainerRequestsError =
    GetOwnWasteContainerRequestsErrors[keyof GetOwnWasteContainerRequestsErrors];

export type GetOwnWasteContainerRequestsResponses = {
    /**
     * OK
     */
    200: Array<WasteContainerRequestDto>;
};

export type GetOwnWasteContainerRequestsResponse =
    GetOwnWasteContainerRequestsResponses[keyof GetOwnWasteContainerRequestsResponses];

export type DeleteWasteCollectionFormData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/waste-collection-forms/{id}";
};

export type DeleteWasteCollectionFormErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteWasteCollectionFormError = DeleteWasteCollectionFormErrors[keyof DeleteWasteCollectionFormErrors];

export type DeleteWasteCollectionFormResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetWasteCollectionFormByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/waste-collection-forms/{id}";
};

export type GetWasteCollectionFormByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetWasteCollectionFormByIdError = GetWasteCollectionFormByIdErrors[keyof GetWasteCollectionFormByIdErrors];

export type GetWasteCollectionFormByIdResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type GetWasteCollectionFormByIdResponse =
    GetWasteCollectionFormByIdResponses[keyof GetWasteCollectionFormByIdResponses];

export type GetWasteCollectionFormsReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria in format: fieldName,asc|desc
         */
        sort?: string;
        /**
         * Form UUID identifier
         */
        id?: string;
        /**
         * School UUID identifier
         */
        schoolId?: string;
        /**
         * Contact person name
         */
        contactPersonName?: string;
        /**
         * Form validation status
         */
        isValidated?: boolean;
        /**
         * Form processing status
         */
        isProcessed?: boolean;
        /**
         * Edition UUID (auto-set if missing)
         */
        editionId?: string;
        filterDTO: WasteCollectionFormReportDto;
        pageable: Pageable;
    };
    url: "/api/waste-collection-forms/report";
};

export type GetWasteCollectionFormsReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetWasteCollectionFormsReportError =
    GetWasteCollectionFormsReportErrors[keyof GetWasteCollectionFormsReportErrors];

export type GetWasteCollectionFormsReportResponses = {
    /**
     * OK
     */
    200: PageWasteCollectionFormReportDto;
};

export type GetWasteCollectionFormsReportResponse =
    GetWasteCollectionFormsReportResponses[keyof GetWasteCollectionFormsReportResponses];

export type GetDefaultWasteCollectionFormData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/waste-collection-forms/default";
};

export type GetDefaultWasteCollectionFormErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultWasteCollectionFormError =
    GetDefaultWasteCollectionFormErrors[keyof GetDefaultWasteCollectionFormErrors];

export type GetDefaultWasteCollectionFormResponses = {
    /**
     * OK
     */
    200: WasteCollectionFormDto;
};

export type GetDefaultWasteCollectionFormResponse =
    GetDefaultWasteCollectionFormResponses[keyof GetDefaultWasteCollectionFormResponses];

export type GetUsersWithSchoolRequestsReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria in format: fieldName,asc|desc
         */
        sort?: string;
        /**
         * Professor user UUID identifier
         */
        userId?: string;
        /**
         * Professor name
         */
        nume?: string;
        /**
         * Professor email address
         */
        email?: string;
        /**
         * Professor phone number
         */
        telefon?: string;
        /**
         * Account enabled status
         */
        isEnabled?: boolean;
        /**
         * Reason for account rejection
         */
        rejectReason?: string;
        /**
         * Phone call contact notes
         */
        phoneCallNote?: string;
        /**
         * School registration form completion status
         */
        hasSchoolRegistrationFormCompleted?: boolean;
        /**
         * Professor registration timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        timestampInregistrare?: Date;
        /**
         * School registration request UUID
         */
        schoolRequestId?: string;
        /**
         * Request approval status (PENDING, APPROVED, REJECTED)
         */
        approvalStatus?: "PENDING" | "APPROVED" | "REJECTED";
        /**
         * Admin rejection reason
         */
        adminRejectReason?: string;
        /**
         * Form submission timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        timestampFormularInscriere?: Date;
        /**
         * School name
         */
        numeInstitutieInvatamant?: string;
        /**
         * School code
         */
        codSe?: string;
        /**
         * School numeric code
         */
        codSeNumeric?: number;
        /**
         * Tax identification number
         */
        cui?: string;
        /**
         * SIIIR unit code
         */
        codSiiirUnitate?: string;
        /**
         * Legal representative name
         */
        numeReprezentatLegal?: string;
        /**
         * Institution phone number
         */
        telefonInstitutie?: string;
        /**
         * Number of students
         */
        numarElevi?: number;
        /**
         * Has waste collection containers
         */
        detineRecipiente?: boolean;
        /**
         * Delivery address same as school
         */
        adresaLivrareAceeasiCuScoala?: boolean;
        /**
         * School address UUID
         */
        adresaId?: string;
        /**
         * School address: county
         */
        adresaJudet?: string;
        /**
         * School address: city
         */
        adresaOras?: string;
        /**
         * School address: commune
         */
        adresaComuna?: string;
        /**
         * School address: village
         */
        adresaSat?: string;
        /**
         * School address: street
         */
        adresaStrada?: string;
        /**
         * School address: street number
         */
        adresaNumar?: string;
        /**
         * School address: postal code
         */
        adresaCodPostal?: string;
        /**
         * School address: block
         */
        adresaBloc?: string;
        /**
         * School address: staircase
         */
        adresaScara?: string;
        /**
         * School address: floor
         */
        adresaEtaj?: string;
        /**
         * School address: apartment
         */
        adresaApartament?: string;
        /**
         * Delivery address UUID
         */
        adresaLivrareId?: string;
        /**
         * Delivery address: county
         */
        adresaLivrareJudet?: string;
        /**
         * Delivery address: city
         */
        adresaLivrareOras?: string;
        /**
         * Delivery address: commune
         */
        adresaLivrareComuna?: string;
        /**
         * Delivery address: village
         */
        adresaLivrareSat?: string;
        /**
         * Delivery address: street
         */
        adresaLivrareStrada?: string;
        /**
         * Delivery address: street number
         */
        adresaLivrareNumar?: string;
        /**
         * Delivery address: postal code
         */
        adresaLivrareCodPostal?: string;
        /**
         * Delivery address: block
         */
        adresaLivrareBloc?: string;
        /**
         * Delivery address: staircase
         */
        adresaLivrareScara?: string;
        /**
         * Delivery address: floor
         */
        adresaLivrareEtaj?: string;
        /**
         * Delivery address: apartment
         */
        adresaLivrareApartament?: string;
        pageable: Pageable;
        filters: {
            [key: string]: string;
        };
    };
    url: "/api/users/school-requests/report";
};

export type GetUsersWithSchoolRequestsReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetUsersWithSchoolRequestsReportError =
    GetUsersWithSchoolRequestsReportErrors[keyof GetUsersWithSchoolRequestsReportErrors];

export type GetUsersWithSchoolRequestsReportResponses = {
    /**
     * OK
     */
    200: PageProfesorReportDto;
};

export type GetUsersWithSchoolRequestsReportResponse =
    GetUsersWithSchoolRequestsReportResponses[keyof GetUsersWithSchoolRequestsReportResponses];

export type GetSchoolClassesData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/users/school-classes-dropdown";
};

export type GetSchoolClassesErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolClassesError = GetSchoolClassesErrors[keyof GetSchoolClassesErrors];

export type GetSchoolClassesResponses = {
    /**
     * OK
     */
    200: Array<string>;
};

export type GetSchoolClassesResponse = GetSchoolClassesResponses[keyof GetSchoolClassesResponses];

export type GetUsersReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria in format: fieldName,asc|desc
         */
        sort?: string;
        /**
         * User UUID identifier
         */
        id?: string;
        /**
         * User full name
         */
        nume?: string;
        /**
         * User email address
         */
        email?: string;
        /**
         * User phone number
         */
        telefon?: string;
        /**
         * Account enabled status
         */
        isEnabled?: boolean;
        /**
         * User role (ADMIN, PROFESOR, ELEV, LOGISTIC, DBEST)
         */
        role?: string;
        /**
         * School registration form completed status
         */
        hasSchoolRegistrationFormCompleted?: boolean;
        /**
         * Reason for account rejection/deactivation
         */
        rejectReason?: string;
        /**
         * Student class (for ELEV role)
         */
        clasa?: string;
        /**
         * Account creation timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        timestamp?: Date;
        /**
         * Last login timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        lastLogin?: Date;
        /**
         * Associated school UUID (for PROFESOR role)
         */
        schoolId?: string;
        /**
         * Associated company UUID
         */
        companyId?: string;
        /**
         * Edition UUID. If not provided, uses current user's edition.
         */
        editionId?: string;
        /**
         * ADMIN only. When true, returns users across ALL editions instead of scoping to the current/selected edition. Ignored for non-ADMIN callers, and ignored when combined with role=ELEV (avoids mixing duplicate cross-edition ELEV accounts).
         */
        toateEditiile?: boolean;
        /**
         * Phone call notes for contact tracing
         */
        phoneCallNote?: string;
        filterDTO: UserDto;
        pageable: Pageable;
    };
    url: "/api/users/report";
};

export type GetUsersReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetUsersReportError = GetUsersReportErrors[keyof GetUsersReportErrors];

export type GetUsersReportResponses = {
    /**
     * OK
     */
    200: PageUserDto;
};

export type GetUsersReportResponse = GetUsersReportResponses[keyof GetUsersReportResponses];

export type GetContactsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/users/contacts";
};

export type GetContactsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetContactsError = GetContactsErrors[keyof GetContactsErrors];

export type GetContactsResponses = {
    /**
     * OK
     */
    200: Array<UserContactDto>;
};

export type GetContactsResponse = GetContactsResponses[keyof GetContactsResponses];

export type GetOwnTicketRedemptionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/ticket-redemptions/own";
};

export type GetOwnTicketRedemptionsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOwnTicketRedemptionsError = GetOwnTicketRedemptionsErrors[keyof GetOwnTicketRedemptionsErrors];

export type GetOwnTicketRedemptionsResponses = {
    /**
     * OK
     */
    200: Array<TicketRedemptionDto>;
};

export type GetOwnTicketRedemptionsResponse = GetOwnTicketRedemptionsResponses[keyof GetOwnTicketRedemptionsResponses];

export type GetStudentLeaderboardData = {
    body?: never;
    path?: never;
    query: {
        filter: StudentLeaderboardRowDto;
        pageable: Pageable;
    };
    url: "/api/students/leaderboard";
};

export type GetStudentLeaderboardErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetStudentLeaderboardError = GetStudentLeaderboardErrors[keyof GetStudentLeaderboardErrors];

export type GetStudentLeaderboardResponses = {
    /**
     * OK
     */
    200: PageStudentLeaderboardRowDto;
};

export type GetStudentLeaderboardResponse = GetStudentLeaderboardResponses[keyof GetStudentLeaderboardResponses];

export type DeleteSlideData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/slides/{id}";
};

export type DeleteSlideErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteSlideError = DeleteSlideErrors[keyof DeleteSlideErrors];

export type DeleteSlideResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetSlideByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/slides/{id}";
};

export type GetSlideByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSlideByIdError = GetSlideByIdErrors[keyof GetSlideByIdErrors];

export type GetSlideByIdResponses = {
    /**
     * OK
     */
    200: SlideDto;
};

export type GetSlideByIdResponse = GetSlideByIdResponses[keyof GetSlideByIdResponses];

export type GetDefaultSlideData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/slides/default";
};

export type GetDefaultSlideErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultSlideError = GetDefaultSlideErrors[keyof GetDefaultSlideErrors];

export type GetDefaultSlideResponses = {
    /**
     * OK
     */
    200: SlideDto;
};

export type GetDefaultSlideResponse = GetDefaultSlideResponses[keyof GetDefaultSlideResponses];

export type DownloadProtocolDeColaborareData = {
    body?: never;
    path: {
        schoolId: string;
    };
    query?: never;
    url: "/api/schools/{schoolId}/protocol-de-colaborare";
};

export type DownloadProtocolDeColaborareErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DownloadProtocolDeColaborareError =
    DownloadProtocolDeColaborareErrors[keyof DownloadProtocolDeColaborareErrors];

export type DownloadProtocolDeColaborareResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DownloadProtocolDeColaborareResponse =
    DownloadProtocolDeColaborareResponses[keyof DownloadProtocolDeColaborareResponses];

export type DeleteSchoolData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/schools/{id}";
};

export type DeleteSchoolErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteSchoolError = DeleteSchoolErrors[keyof DeleteSchoolErrors];

export type DeleteSchoolResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetSchoolByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/schools/{id}";
};

export type GetSchoolByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolByIdError = GetSchoolByIdErrors[keyof GetSchoolByIdErrors];

export type GetSchoolByIdResponses = {
    /**
     * OK
     */
    200: SchoolDto;
};

export type GetSchoolByIdResponse = GetSchoolByIdResponses[keyof GetSchoolByIdResponses];

export type GetSchoolPointsBalanceData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/schools/{id}/points-balance";
};

export type GetSchoolPointsBalanceErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolPointsBalanceError = GetSchoolPointsBalanceErrors[keyof GetSchoolPointsBalanceErrors];

export type GetSchoolPointsBalanceResponses = {
    /**
     * OK
     */
    200: SchoolBalanceDto;
};

export type GetSchoolPointsBalanceResponse = GetSchoolPointsBalanceResponses[keyof GetSchoolPointsBalanceResponses];

export type GetSchoolsStatusReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria (e.g., 'pointsGrandTotal,desc')
         */
        sort?: string;
        /**
         * School UUID identifier
         */
        id?: string;
        /**
         * School name
         */
        numeInstitutieInvatamant?: string;
        /**
         * School code
         */
        codSe?: string;
        /**
         * School numeric code
         */
        codSeNumeric?: string;
        /**
         * Tax identification number
         */
        cui?: string;
        /**
         * SIIIR unit code
         */
        codSiiirUnitate?: string;
        /**
         * Edition UUID. If not provided, uses current user's edition.
         */
        editionId?: string;
        /**
         * Total DEEE (electrical equipment) weight in kg
         */
        totalDeeeKg?: number;
        /**
         * Total DBA (batteries) weight in kg
         */
        totalDbaKg?: number;
        /**
         * Total bulbs and neon weight in kg
         */
        totalBecuriSiNeoaneKg?: number;
        /**
         * Total waste weight in kg
         */
        totalKg?: number;
        /**
         * Points from LESSON type lessons
         */
        pointsLesson?: number;
        /**
         * Points from CLASS_EXERCISE type lessons
         */
        pointsClassExercise?: number;
        /**
         * Points from practical activities
         */
        pointsPracticalActivity?: number;
        /**
         * Points from homework
         */
        pointsHomework?: number;
        /**
         * Points from daily challenges
         */
        pointsDailyChallenge?: number;
        /**
         * Points from monthly challenges
         */
        pointsMonthlyChallenge?: number;
        /**
         * Number of completed lessons
         */
        countLesson?: number;
        /**
         * Number of completed class exercises
         */
        countClassExercise?: number;
        /**
         * Number of approved practical activities
         */
        countPracticalActivity?: number;
        /**
         * Number of completed homework
         */
        countHomework?: number;
        /**
         * Number of approved daily challenges
         */
        countDailyChallenge?: number;
        /**
         * Number of approved monthly challenges
         */
        countMonthlyChallenge?: number;
        /**
         * Subtotal: sum of all lesson type points
         */
        pointsAllLessonsTotal?: number;
        /**
         * Subtotal: points from waste collection forms
         */
        pointsWasteCollectionTotal?: number;
        /**
         * Grand total: pointsAllLessonsTotal + pointsWasteCollectionTotal
         */
        pointsGrandTotal?: number;
        /**
         * Main address: county
         */
        mainJudet?: string;
        /**
         * Main address: city
         */
        mainOras?: string;
        /**
         * Main address: commune
         */
        mainComuna?: string;
        /**
         * Main address: village
         */
        mainSat?: string;
        /**
         * Main address: street
         */
        mainStrada?: string;
        /**
         * Main address: street number
         */
        mainNumar?: string;
        /**
         * Main address: postal code
         */
        mainCodPostal?: string;
        /**
         * Main address: block
         */
        mainBloc?: string;
        /**
         * Main address: staircase
         */
        mainScara?: string;
        /**
         * Main address: floor
         */
        mainEtaj?: string;
        /**
         * Main address: apartment
         */
        mainApartament?: string;
        /**
         * Delivery address: county
         */
        deliveryJudet?: string;
        /**
         * Delivery address: city
         */
        deliveryOras?: string;
        /**
         * Delivery address: commune
         */
        deliveryComuna?: string;
        /**
         * Delivery address: village
         */
        deliverySat?: string;
        /**
         * Delivery address: street
         */
        deliveryStrada?: string;
        /**
         * Delivery address: street number
         */
        deliveryNumar?: string;
        /**
         * Delivery address: postal code
         */
        deliveryCodPostal?: string;
        /**
         * Delivery address: block
         */
        deliveryBloc?: string;
        /**
         * Delivery address: staircase
         */
        deliveryScara?: string;
        /**
         * Delivery address: floor
         */
        deliveryEtaj?: string;
        /**
         * Delivery address: apartment
         */
        deliveryApartament?: string;
        /**
         * Professor/contact person name
         */
        professorNume?: string;
        /**
         * Professor/contact person email
         */
        professorEmail?: string;
        /**
         * Professor/contact person phone
         */
        professorTelefon?: string;
        /**
         * Number of students
         */
        numarElevi?: number;
        /**
         * Has waste collection containers
         */
        detineRecipiente?: boolean;
        /**
         * Delivery address same as school
         */
        adresaLivrareAceeasiCuScoala?: boolean;
        /**
         * School last update timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        updatedAt?: Date;
        pageable: Pageable;
        filters: {
            [key: string]: string;
        };
    };
    url: "/api/schools/status-report";
};

export type GetSchoolsStatusReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolsStatusReportError = GetSchoolsStatusReportErrors[keyof GetSchoolsStatusReportErrors];

export type GetSchoolsStatusReportResponses = {
    /**
     * OK
     */
    200: PageEditionReportDto;
};

export type GetSchoolsStatusReportResponse = GetSchoolsStatusReportResponses[keyof GetSchoolsStatusReportResponses];

export type GetSchoolsReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria in format: fieldName,asc|desc (e.g., 'numeInstitutieInvatamant,asc')
         */
        sort?: string;
        /**
         * School UUID identifier
         */
        id?: string;
        /**
         * School name (supports partial matching)
         */
        numeInstitutieInvatamant?: string;
        /**
         * School code
         */
        codSe?: string;
        /**
         * School numeric code
         */
        codSeNumeric?: string;
        /**
         * Tax identification number
         */
        cui?: string;
        /**
         * SIIIR unit code
         */
        codSiiirUnitate?: string;
        /**
         * Edition UUID. If not provided, uses current user's edition.
         */
        editionId?: string;
        /**
         * School last update timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        updatedAt?: Date;
        filterDTO: SchoolReportDto;
        pageable: Pageable;
    };
    url: "/api/schools/report";
};

export type GetSchoolsReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolsReportError = GetSchoolsReportErrors[keyof GetSchoolsReportErrors];

export type GetSchoolsReportResponses = {
    /**
     * OK
     */
    200: PageSchoolReportDto;
};

export type GetSchoolsReportResponse = GetSchoolsReportResponses[keyof GetSchoolsReportResponses];

export type GetSchoolRegistrationStatusData = {
    body?: never;
    path?: never;
    query: {
        /**
         * SIIIR unit code of the school
         */
        codSiiirUnitate: string;
    };
    url: "/api/schools/registration-status";
};

export type GetSchoolRegistrationStatusErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolRegistrationStatusError =
    GetSchoolRegistrationStatusErrors[keyof GetSchoolRegistrationStatusErrors];

export type GetSchoolRegistrationStatusResponses = {
    /**
     * OK
     */
    200: SchoolRegistrationStatusDto;
};

export type GetSchoolRegistrationStatusResponse =
    GetSchoolRegistrationStatusResponses[keyof GetSchoolRegistrationStatusResponses];

export type GetOwnSchoolData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools/own";
};

export type GetOwnSchoolErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOwnSchoolError = GetOwnSchoolErrors[keyof GetOwnSchoolErrors];

export type GetOwnSchoolResponses = {
    /**
     * OK
     */
    200: SchoolDto;
};

export type GetOwnSchoolResponse = GetOwnSchoolResponses[keyof GetOwnSchoolResponses];

export type DownloadOwnProtocolDeColaborareData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools/own/protocol-de-colaborare";
};

export type DownloadOwnProtocolDeColaborareErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DownloadOwnProtocolDeColaborareError =
    DownloadOwnProtocolDeColaborareErrors[keyof DownloadOwnProtocolDeColaborareErrors];

export type DownloadOwnProtocolDeColaborareResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DownloadOwnProtocolDeColaborareResponse =
    DownloadOwnProtocolDeColaborareResponses[keyof DownloadOwnProtocolDeColaborareResponses];

export type GetOwnSchoolPointsBalanceData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools/own/points-balance";
};

export type GetOwnSchoolPointsBalanceErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOwnSchoolPointsBalanceError = GetOwnSchoolPointsBalanceErrors[keyof GetOwnSchoolPointsBalanceErrors];

export type GetOwnSchoolPointsBalanceResponses = {
    /**
     * OK
     */
    200: SchoolBalanceDto;
};

export type GetOwnSchoolPointsBalanceResponse =
    GetOwnSchoolPointsBalanceResponses[keyof GetOwnSchoolPointsBalanceResponses];

export type GetSchoolsImportDataData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        filterDTO: SchoolDataImportDto;
        pageable: Pageable;
    };
    url: "/api/schools/import-data";
};

export type GetSchoolsImportDataErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolsImportDataError = GetSchoolsImportDataErrors[keyof GetSchoolsImportDataErrors];

export type GetSchoolsImportDataResponses = {
    /**
     * OK
     */
    200: PageSchoolDataImportDto;
};

export type GetSchoolsImportDataResponse = GetSchoolsImportDataResponses[keyof GetSchoolsImportDataResponses];

export type GetSchoolsDropdownData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools/dropdown";
};

export type GetSchoolsDropdownErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolsDropdownError = GetSchoolsDropdownErrors[keyof GetSchoolsDropdownErrors];

export type GetSchoolsDropdownResponses = {
    /**
     * OK
     */
    200: Array<SchoolDropdownDto>;
};

export type GetSchoolsDropdownResponse = GetSchoolsDropdownResponses[keyof GetSchoolsDropdownResponses];

export type GetDefaultSchoolData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools/default";
};

export type GetDefaultSchoolErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultSchoolError = GetDefaultSchoolErrors[keyof GetDefaultSchoolErrors];

export type GetDefaultSchoolResponses = {
    /**
     * OK
     */
    200: SchoolDto;
};

export type GetDefaultSchoolResponse = GetDefaultSchoolResponses[keyof GetDefaultSchoolResponses];

export type GetCountiesListData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/schools/counties";
};

export type GetCountiesListErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetCountiesListError = GetCountiesListErrors[keyof GetCountiesListErrors];

export type GetCountiesListResponses = {
    /**
     * OK
     */
    200: Array<string>;
};

export type GetCountiesListResponse = GetCountiesListResponses[keyof GetCountiesListResponses];

export type DeleteSchoolRequestData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/school-requests/{id}";
};

export type DeleteSchoolRequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteSchoolRequestError = DeleteSchoolRequestErrors[keyof DeleteSchoolRequestErrors];

export type DeleteSchoolRequestResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetSchoolRequestByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/school-requests/{id}";
};

export type GetSchoolRequestByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolRequestByIdError = GetSchoolRequestByIdErrors[keyof GetSchoolRequestByIdErrors];

export type GetSchoolRequestByIdResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type GetSchoolRequestByIdResponse = GetSchoolRequestByIdResponses[keyof GetSchoolRequestByIdResponses];

export type GetSchoolRequestByUserIdData = {
    body?: never;
    path: {
        /**
         * User UUID identifier
         */
        id: string;
    };
    query?: never;
    url: "/api/school-requests/user/{id}";
};

export type GetSchoolRequestByUserIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolRequestByUserIdError = GetSchoolRequestByUserIdErrors[keyof GetSchoolRequestByUserIdErrors];

export type GetSchoolRequestByUserIdResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type GetSchoolRequestByUserIdResponse =
    GetSchoolRequestByUserIdResponses[keyof GetSchoolRequestByUserIdResponses];

export type GetSchoolRequestsReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria in format: fieldName,asc|desc
         */
        sort?: string;
        /**
         * Request UUID identifier
         */
        id?: string;
        /**
         * School name
         */
        numeInstitutieInvatamant?: string;
        /**
         * School code
         */
        codSe?: string;
        /**
         * Tax identification number
         */
        cui?: string;
        /**
         * Approval status (PENDING, APPROVED, REJECTED)
         */
        approvalStatus?: "PENDING" | "APPROVED" | "REJECTED";
        /**
         * Edition UUID (auto-set if missing)
         */
        editionId?: string;
        /**
         * School last update timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        schoolUpdatedAt?: Date;
        filterDTO: SchoolRequestReportDto;
        pageable: Pageable;
    };
    url: "/api/school-requests/report";
};

export type GetSchoolRequestsReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchoolRequestsReportError = GetSchoolRequestsReportErrors[keyof GetSchoolRequestsReportErrors];

export type GetSchoolRequestsReportResponses = {
    /**
     * OK
     */
    200: PageSchoolRequestReportDto;
};

export type GetSchoolRequestsReportResponse = GetSchoolRequestsReportResponses[keyof GetSchoolRequestsReportResponses];

export type GetOwnSchoolRequestData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/school-requests/own";
};

export type GetOwnSchoolRequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOwnSchoolRequestError = GetOwnSchoolRequestErrors[keyof GetOwnSchoolRequestErrors];

export type GetOwnSchoolRequestResponses = {
    /**
     * Cererea profesorului (sau sablonul precompletat din editia trecuta, fara id)
     */
    200: SchoolRequestDto;
    /**
     * Profesorul nu are inca nicio cerere, fara corp
     */
    204: void;
};

export type GetOwnSchoolRequestResponse = GetOwnSchoolRequestResponses[keyof GetOwnSchoolRequestResponses];

export type GetIstoricProfesoriData = {
    body?: never;
    path?: never;
    query?: {
        codSiiirUnitate?: string;
    };
    url: "/api/school-requests/istoric-profesori";
};

export type GetIstoricProfesoriErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetIstoricProfesoriError = GetIstoricProfesoriErrors[keyof GetIstoricProfesoriErrors];

export type GetIstoricProfesoriResponses = {
    /**
     * OK
     */
    200: Array<IstoricProfesorDto>;
};

export type GetIstoricProfesoriResponse = GetIstoricProfesoriResponses[keyof GetIstoricProfesoriResponses];

export type GetDefaultSchoolRequestData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/school-requests/default";
};

export type GetDefaultSchoolRequestErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultSchoolRequestError = GetDefaultSchoolRequestErrors[keyof GetDefaultSchoolRequestErrors];

export type GetDefaultSchoolRequestResponses = {
    /**
     * OK
     */
    200: SchoolRequestDto;
};

export type GetDefaultSchoolRequestResponse = GetDefaultSchoolRequestResponses[keyof GetDefaultSchoolRequestResponses];

export type GetSchedulerRunsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Filtru dupa numele jobului
         */
        job?: string;
        page?: number;
        size?: number;
        pageable: Pageable;
    };
    url: "/api/scheduler-runs";
};

export type GetSchedulerRunsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetSchedulerRunsError = GetSchedulerRunsErrors[keyof GetSchedulerRunsErrors];

export type GetSchedulerRunsResponses = {
    /**
     * OK
     */
    200: PageSchedulerRunDto;
};

export type GetSchedulerRunsResponse = GetSchedulerRunsResponses[keyof GetSchedulerRunsResponses];

export type GetParentalApprovalByUserData = {
    body?: never;
    path: {
        userId: string;
    };
    query: {
        editionId: string;
    };
    url: "/api/parental-approvals/users/{userId}";
};

export type GetParentalApprovalByUserErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetParentalApprovalByUserError = GetParentalApprovalByUserErrors[keyof GetParentalApprovalByUserErrors];

export type GetParentalApprovalByUserResponses = {
    /**
     * OK
     */
    200: ParentalApprovalDto;
};

export type GetParentalApprovalByUserResponse =
    GetParentalApprovalByUserResponses[keyof GetParentalApprovalByUserResponses];

export type DeleteOptionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/options/{id}";
};

export type DeleteOptionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteOptionError = DeleteOptionErrors[keyof DeleteOptionErrors];

export type DeleteOptionResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetOptionByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/options/{id}";
};

export type GetOptionByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOptionByIdError = GetOptionByIdErrors[keyof GetOptionByIdErrors];

export type GetOptionByIdResponses = {
    /**
     * OK
     */
    200: OptionDto;
};

export type GetOptionByIdResponse = GetOptionByIdResponses[keyof GetOptionByIdResponses];

export type GetDefaultOptionData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/options/default";
};

export type GetDefaultOptionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultOptionError = GetDefaultOptionErrors[keyof GetDefaultOptionErrors];

export type GetDefaultOptionResponses = {
    /**
     * OK
     */
    200: OptionDto;
};

export type GetDefaultOptionResponse = GetDefaultOptionResponses[keyof GetDefaultOptionResponses];

export type DeleteNotificationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/notifications/{id}";
};

export type DeleteNotificationErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteNotificationError = DeleteNotificationErrors[keyof DeleteNotificationErrors];

export type DeleteNotificationResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetNotificationByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/notifications/{id}";
};

export type GetNotificationByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetNotificationByIdError = GetNotificationByIdErrors[keyof GetNotificationByIdErrors];

export type GetNotificationByIdResponses = {
    /**
     * OK
     */
    200: NotificationDto;
};

export type GetNotificationByIdResponse = GetNotificationByIdResponses[keyof GetNotificationByIdResponses];

export type GetNotificationReceiversStatusData = {
    body?: never;
    path: {
        /**
         * Notification UUID identifier
         */
        id: string;
    };
    query?: never;
    url: "/api/notifications/{id}/receivers";
};

export type GetNotificationReceiversStatusErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetNotificationReceiversStatusError =
    GetNotificationReceiversStatusErrors[keyof GetNotificationReceiversStatusErrors];

export type GetNotificationReceiversStatusResponses = {
    /**
     * OK
     */
    200: Array<NotificationReadDto>;
};

export type GetNotificationReceiversStatusResponse =
    GetNotificationReceiversStatusResponses[keyof GetNotificationReceiversStatusResponses];

export type GetNotificationsReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria (default: notification.sendAt,desc)
         */
        sort?: string;
        /**
         * Notification UUID identifier
         */
        id?: string;
        /**
         * Edition UUID
         */
        editionId?: string;
        /**
         * Read status
         */
        isRead?: boolean;
        filterDTO: NotificationReportDto;
        pageable: Pageable;
    };
    url: "/api/notifications/report";
};

export type GetNotificationsReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetNotificationsReportError = GetNotificationsReportErrors[keyof GetNotificationsReportErrors];

export type GetNotificationsReportResponses = {
    /**
     * OK
     */
    200: PageNotificationReportDto;
};

export type GetNotificationsReportResponse = GetNotificationsReportResponses[keyof GetNotificationsReportResponses];

export type GetOutboxNotificationsDeprecatedData = {
    body?: never;
    path?: never;
    query: {
        pageable: Pageable;
    };
    url: "/api/notifications/outbox";
};

export type GetOutboxNotificationsDeprecatedErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOutboxNotificationsDeprecatedError =
    GetOutboxNotificationsDeprecatedErrors[keyof GetOutboxNotificationsDeprecatedErrors];

export type GetOutboxNotificationsDeprecatedResponses = {
    /**
     * OK
     */
    200: PageOutboxNotificationDto;
};

export type GetOutboxNotificationsDeprecatedResponse =
    GetOutboxNotificationsDeprecatedResponses[keyof GetOutboxNotificationsDeprecatedResponses];

export type GetInboxNotificationsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        pageable: Pageable;
    };
    url: "/api/notifications/inbox";
};

export type GetInboxNotificationsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetInboxNotificationsError = GetInboxNotificationsErrors[keyof GetInboxNotificationsErrors];

export type GetInboxNotificationsResponses = {
    /**
     * OK
     */
    200: PageInboxNotificationDto;
};

export type GetInboxNotificationsResponse = GetInboxNotificationsResponses[keyof GetInboxNotificationsResponses];

export type GetDefaultNotificationData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/notifications/default";
};

export type GetDefaultNotificationErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultNotificationError = GetDefaultNotificationErrors[keyof GetDefaultNotificationErrors];

export type GetDefaultNotificationResponses = {
    /**
     * OK
     */
    200: NotificationDto;
};

export type GetDefaultNotificationResponse = GetDefaultNotificationResponses[keyof GetDefaultNotificationResponses];

export type DeleteLessonData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/lessons/{id}";
};

export type DeleteLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteLessonError = DeleteLessonErrors[keyof DeleteLessonErrors];

export type DeleteLessonResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetLessonByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/lessons/{id}";
};

export type GetLessonByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetLessonByIdError = GetLessonByIdErrors[keyof GetLessonByIdErrors];

export type GetLessonByIdResponses = {
    /**
     * OK
     */
    200: LessonDto;
};

export type GetLessonByIdResponse = GetLessonByIdResponses[keyof GetLessonByIdResponses];

export type DescarcaRaspunsuriPdfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/lessons/{id}/raspunsuri-pdf";
};

export type DescarcaRaspunsuriPdfErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DescarcaRaspunsuriPdfError = DescarcaRaspunsuriPdfErrors[keyof DescarcaRaspunsuriPdfErrors];

export type DescarcaRaspunsuriPdfResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DescarcaRaspunsuriPdfResponse = DescarcaRaspunsuriPdfResponses[keyof DescarcaRaspunsuriPdfResponses];

export type DescarcaExercitiiPdfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/lessons/{id}/exercitii-pdf";
};

export type DescarcaExercitiiPdfErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DescarcaExercitiiPdfError = DescarcaExercitiiPdfErrors[keyof DescarcaExercitiiPdfErrors];

export type DescarcaExercitiiPdfResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DescarcaExercitiiPdfResponse = DescarcaExercitiiPdfResponses[keyof DescarcaExercitiiPdfResponses];

export type GetLessonsByTypeData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Lesson type (PRACTICAL_ACTIVITY, HOMEWORK, DAILY_CHALLENGE, MONTHLY_CHALLENGE)
         */
        type: string;
    };
    url: "/api/lessons/types";
};

export type GetLessonsByTypeErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetLessonsByTypeError = GetLessonsByTypeErrors[keyof GetLessonsByTypeErrors];

export type GetLessonsByTypeResponses = {
    /**
     * OK
     */
    200: Array<LessonDto>;
};

export type GetLessonsByTypeResponse = GetLessonsByTypeResponses[keyof GetLessonsByTypeResponses];

export type GetDefaultLessonData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/lessons/default";
};

export type GetDefaultLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultLessonError = GetDefaultLessonErrors[keyof GetDefaultLessonErrors];

export type GetDefaultLessonResponses = {
    /**
     * OK
     */
    200: LessonDto;
};

export type GetDefaultLessonResponse = GetDefaultLessonResponses[keyof GetDefaultLessonResponses];

export type GetLessonProgressByTypeData = {
    body?: never;
    path?: never;
    query?: {
        type?: string;
        schoolId?: string;
    };
    url: "/api/lessons/answers";
};

export type GetLessonProgressByTypeErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetLessonProgressByTypeError = GetLessonProgressByTypeErrors[keyof GetLessonProgressByTypeErrors];

export type GetLessonProgressByTypeResponses = {
    /**
     * OK
     */
    200: Array<LessonProgressDto>;
};

export type GetLessonProgressByTypeResponse = GetLessonProgressByTypeResponses[keyof GetLessonProgressByTypeResponses];

export type GetAnswersForSubmissionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/lessons/answers/{id}/answers";
};

export type GetAnswersForSubmissionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAnswersForSubmissionError = GetAnswersForSubmissionErrors[keyof GetAnswersForSubmissionErrors];

export type GetAnswersForSubmissionResponses = {
    /**
     * OK
     */
    200: Array<AnswerDto>;
};

export type GetAnswersForSubmissionResponse = GetAnswersForSubmissionResponses[keyof GetAnswersForSubmissionResponses];

export type GetLessonAnswersReportData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page number (0-indexed)
         */
        page?: number;
        /**
         * Number of records per page
         */
        size?: number;
        /**
         * Sort criteria in format: fieldName,asc|desc
         */
        sort?: string;
        /**
         * Lesson answer UUID identifier
         */
        id?: string;
        /**
         * Points awarded for this lesson answer
         */
        points?: number;
        /**
         * Approval status (true/false/null)
         */
        isApproved?: boolean;
        /**
         * Reason for rejection if not approved
         */
        rejectReason?: string;
        /**
         * Lesson answer submission timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        timestamp?: Date;
        /**
         * Lesson approval timestamp in ISO 8601 format (e.g., 2025-10-19T14:30:00). Time zone: Europe/Bucharest.
         */
        approvedAt?: Date;
        /**
         * Lesson UUID identifier
         */
        "lesson.id"?: string;
        /**
         * Lesson title
         */
        "lesson.title"?: string;
        /**
         * Lesson type alias (PRACTICAL_ACTIVITY, HOMEWORK, DAILY_CHALLENGE, MONTHLY_CHALLENGE)
         */
        "lesson.typeAlias"?: string;
        /**
         * User UUID identifier
         */
        "user.id"?: string;
        /**
         * Student name
         */
        "user.nume"?: string;
        /**
         * Student email
         */
        "user.email"?: string;
        /**
         * School UUID identifier
         */
        "user.school.id"?: string;
        /**
         * School name
         */
        "user.school.numeInstitutieInvatamant"?: string;
        /**
         * School code
         */
        "user.school.codSe"?: string;
        /**
         * School numeric code
         */
        "user.school.codSeNumeric"?: number;
        /**
         * Edition UUID. If not provided, uses current user's edition.
         */
        editionId?: string;
        /**
         * Name typed by the collaborator who submitted the answer
         */
        submittedByName?: string;
        /**
         * Label of the collaborator link used for submission
         */
        "collaboratorLink.label"?: string;
        filterDTO: LessonAnswerReportDto;
        pageable: Pageable;
    };
    url: "/api/lessons/answers/report";
};

export type GetLessonAnswersReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetLessonAnswersReportError = GetLessonAnswersReportErrors[keyof GetLessonAnswersReportErrors];

export type GetLessonAnswersReportResponses = {
    /**
     * OK
     */
    200: PageLessonAnswerReportDto;
};

export type GetLessonAnswersReportResponse = GetLessonAnswersReportResponses[keyof GetLessonAnswersReportResponses];

export type GetAllFoldersData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/files/folders";
};

export type GetAllFoldersErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAllFoldersError = GetAllFoldersErrors[keyof GetAllFoldersErrors];

export type GetAllFoldersResponses = {
    /**
     * OK
     */
    200: Array<string>;
};

export type GetAllFoldersResponse = GetAllFoldersResponses[keyof GetAllFoldersResponses];

export type ExportReportData = {
    body?: never;
    path?: never;
    query: {
        url: string;
    };
    url: "/api/files/excel-reports";
};

export type ExportReportErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type ExportReportError = ExportReportErrors[keyof ExportReportErrors];

export type ExportReportResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type ExportReportResponse = ExportReportResponses[keyof ExportReportResponses];

export type DeleteFaqEntryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/faq/{id}";
};

export type DeleteFaqEntryErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteFaqEntryError = DeleteFaqEntryErrors[keyof DeleteFaqEntryErrors];

export type DeleteFaqEntryResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/faq/{id}";
};

export type GetByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetByIdError = GetByIdErrors[keyof GetByIdErrors];

export type GetByIdResponses = {
    /**
     * OK
     */
    200: FaqEntryDto;
};

export type GetByIdResponse = GetByIdResponses[keyof GetByIdResponses];

export type GetDefaultData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/faq/default";
};

export type GetDefaultErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultError = GetDefaultErrors[keyof GetDefaultErrors];

export type GetDefaultResponses = {
    /**
     * OK
     */
    200: FaqEntryDto;
};

export type GetDefaultResponse = GetDefaultResponses[keyof GetDefaultResponses];

export type DeleteEditionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/editions/{id}";
};

export type DeleteEditionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteEditionError = DeleteEditionErrors[keyof DeleteEditionErrors];

export type DeleteEditionResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetEditionByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/editions/{id}";
};

export type GetEditionByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetEditionByIdError = GetEditionByIdErrors[keyof GetEditionByIdErrors];

export type GetEditionByIdResponses = {
    /**
     * OK
     */
    200: EditionDto;
};

export type GetEditionByIdResponse = GetEditionByIdResponses[keyof GetEditionByIdResponses];

export type GetDefaultEditionData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/editions/default";
};

export type GetDefaultEditionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultEditionError = GetDefaultEditionErrors[keyof GetDefaultEditionErrors];

export type GetDefaultEditionResponses = {
    /**
     * OK
     */
    200: EditionDto;
};

export type GetDefaultEditionResponse = GetDefaultEditionResponses[keyof GetDefaultEditionResponses];

export type GetOnboardingVideoData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/editions/current/onboarding-video";
};

export type GetOnboardingVideoErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetOnboardingVideoError = GetOnboardingVideoErrors[keyof GetOnboardingVideoErrors];

export type GetOnboardingVideoResponses = {
    /**
     * OK
     */
    200: OnboardingVideoDto;
};

export type GetOnboardingVideoResponse = GetOnboardingVideoResponses[keyof GetOnboardingVideoResponses];

export type GetEditionDocumentsData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/editions/current/documents";
};

export type GetEditionDocumentsErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetEditionDocumentsError = GetEditionDocumentsErrors[keyof GetEditionDocumentsErrors];

export type GetEditionDocumentsResponses = {
    /**
     * OK
     */
    200: EditionDocumentsDto;
};

export type GetEditionDocumentsResponse = GetEditionDocumentsResponses[keyof GetEditionDocumentsResponses];

export type DeleteCompanyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/companies/{id}";
};

export type DeleteCompanyErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteCompanyError = DeleteCompanyErrors[keyof DeleteCompanyErrors];

export type DeleteCompanyResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetCompanyByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/companies/{id}";
};

export type GetCompanyByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetCompanyByIdError = GetCompanyByIdErrors[keyof GetCompanyByIdErrors];

export type GetCompanyByIdResponses = {
    /**
     * OK
     */
    200: CompanyDto;
};

export type GetCompanyByIdResponse = GetCompanyByIdResponses[keyof GetCompanyByIdResponses];

export type GetDefaultCompanyData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/companies/default";
};

export type GetDefaultCompanyErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultCompanyError = GetDefaultCompanyErrors[keyof GetDefaultCompanyErrors];

export type GetDefaultCompanyResponses = {
    /**
     * OK
     */
    200: CompanyDto;
};

export type GetDefaultCompanyResponse = GetDefaultCompanyResponses[keyof GetDefaultCompanyResponses];

export type GetCollabInfoData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: "/api/collab/{token}";
};

export type GetCollabInfoErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetCollabInfoError = GetCollabInfoErrors[keyof GetCollabInfoErrors];

export type GetCollabInfoResponses = {
    /**
     * OK
     */
    200: CollabInfoDto;
};

export type GetCollabInfoResponse = GetCollabInfoResponses[keyof GetCollabInfoResponses];

export type GetCollabActivityData = {
    body?: never;
    path: {
        token: string;
        lessonId: string;
    };
    query?: never;
    url: "/api/collab/{token}/activities/{lessonId}";
};

export type GetCollabActivityErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetCollabActivityError = GetCollabActivityErrors[keyof GetCollabActivityErrors];

export type GetCollabActivityResponses = {
    /**
     * OK
     */
    200: LessonDto;
};

export type GetCollabActivityResponse = GetCollabActivityResponses[keyof GetCollabActivityResponses];

export type DescarcaRaspunsuriPdfColabData = {
    body?: never;
    path: {
        token: string;
        lessonId: string;
    };
    query?: never;
    url: "/api/collab/{token}/activities/{lessonId}/raspunsuri-pdf";
};

export type DescarcaRaspunsuriPdfColabErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DescarcaRaspunsuriPdfColabError = DescarcaRaspunsuriPdfColabErrors[keyof DescarcaRaspunsuriPdfColabErrors];

export type DescarcaRaspunsuriPdfColabResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DescarcaRaspunsuriPdfColabResponse =
    DescarcaRaspunsuriPdfColabResponses[keyof DescarcaRaspunsuriPdfColabResponses];

export type DescarcaExercitiiPdfColabData = {
    body?: never;
    path: {
        token: string;
        lessonId: string;
    };
    query?: never;
    url: "/api/collab/{token}/activities/{lessonId}/exercitii-pdf";
};

export type DescarcaExercitiiPdfColabErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DescarcaExercitiiPdfColabError = DescarcaExercitiiPdfColabErrors[keyof DescarcaExercitiiPdfColabErrors];

export type DescarcaExercitiiPdfColabResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DescarcaExercitiiPdfColabResponse =
    DescarcaExercitiiPdfColabResponses[keyof DescarcaExercitiiPdfColabResponses];

export type DeleteAnswerData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/answers/{id}";
};

export type DeleteAnswerErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteAnswerError = DeleteAnswerErrors[keyof DeleteAnswerErrors];

export type DeleteAnswerResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetAnswerByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/answers/{id}";
};

export type GetAnswerByIdErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAnswerByIdError = GetAnswerByIdErrors[keyof GetAnswerByIdErrors];

export type GetAnswerByIdResponses = {
    /**
     * OK
     */
    200: AnswerDto;
};

export type GetAnswerByIdResponse = GetAnswerByIdResponses[keyof GetAnswerByIdResponses];

export type GetAnswersByLessonData = {
    body?: never;
    path: {
        /**
         * Lesson UUID identifier
         */
        lessonId: string;
    };
    query?: never;
    url: "/api/answers/lessons/{lessonId}";
};

export type GetAnswersByLessonErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetAnswersByLessonError = GetAnswersByLessonErrors[keyof GetAnswersByLessonErrors];

export type GetAnswersByLessonResponses = {
    /**
     * OK
     */
    200: Array<AnswerDto>;
};

export type GetAnswersByLessonResponse = GetAnswersByLessonResponses[keyof GetAnswersByLessonResponses];

export type GetStudentAnswersByLessonAndUserData = {
    body?: never;
    path: {
        /**
         * Lesson UUID identifier
         */
        lessonId: string;
        /**
         * Student user UUID identifier
         */
        userId: string;
    };
    query?: never;
    url: "/api/answers/lessons/{lessonId}/students/{userId}";
};

export type GetStudentAnswersByLessonAndUserErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetStudentAnswersByLessonAndUserError =
    GetStudentAnswersByLessonAndUserErrors[keyof GetStudentAnswersByLessonAndUserErrors];

export type GetStudentAnswersByLessonAndUserResponses = {
    /**
     * OK
     */
    200: Array<AnswerDto>;
};

export type GetStudentAnswersByLessonAndUserResponse =
    GetStudentAnswersByLessonAndUserResponses[keyof GetStudentAnswersByLessonAndUserResponses];

export type GetDefaultAnswerData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/answers/default";
};

export type GetDefaultAnswerErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type GetDefaultAnswerError = GetDefaultAnswerErrors[keyof GetDefaultAnswerErrors];

export type GetDefaultAnswerResponses = {
    /**
     * OK
     */
    200: AnswerDto;
};

export type GetDefaultAnswerResponse = GetDefaultAnswerResponses[keyof GetDefaultAnswerResponses];

export type AnalyzeBlobStorageData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/api/admin/blob-analysis";
};

export type AnalyzeBlobStorageErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type AnalyzeBlobStorageError = AnalyzeBlobStorageErrors[keyof AnalyzeBlobStorageErrors];

export type AnalyzeBlobStorageResponses = {
    /**
     * OK
     */
    200: BlobAnalysisResultDto;
};

export type AnalyzeBlobStorageResponse = AnalyzeBlobStorageResponses[keyof AnalyzeBlobStorageResponses];

export type RootData = {
    body?: never;
    path?: never;
    query?: never;
    url: "/";
};

export type RootErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type RootError = RootErrors[keyof RootErrors];

export type RootResponses = {
    /**
     * OK
     */
    200: string;
};

export type RootResponse = RootResponses[keyof RootResponses];

export type DeleteTicketTierData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: "/api/ticket-tiers/{id}";
};

export type DeleteTicketTierErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteTicketTierError = DeleteTicketTierErrors[keyof DeleteTicketTierErrors];

export type DeleteTicketTierResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: unknown;
    };
};

export type DeleteTicketTierResponse = DeleteTicketTierResponses[keyof DeleteTicketTierResponses];

export type RevokeCollaboratorLinkData = {
    body?: never;
    path: {
        schoolId: string;
        linkId: string;
    };
    query?: never;
    url: "/api/schools/{schoolId}/collaborator-links/{linkId}";
};

export type RevokeCollaboratorLinkErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type RevokeCollaboratorLinkError = RevokeCollaboratorLinkErrors[keyof RevokeCollaboratorLinkErrors];

export type RevokeCollaboratorLinkResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type DeleteLessonAnswersByUserLessonAndEditionData = {
    body?: never;
    path: {
        /**
         * Student user UUID identifier
         */
        userId: string;
        /**
         * Lesson UUID identifier
         */
        lessonId: string;
        /**
         * Edition UUID identifier
         */
        editionId: string;
    };
    query?: never;
    url: "/api/lessons/answers/users/{userId}/lessons/{lessonId}/editions/{editionId}";
};

export type DeleteLessonAnswersByUserLessonAndEditionErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteLessonAnswersByUserLessonAndEditionError =
    DeleteLessonAnswersByUserLessonAndEditionErrors[keyof DeleteLessonAnswersByUserLessonAndEditionErrors];

export type DeleteLessonAnswersByUserLessonAndEditionResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type DeleteFileData = {
    body?: never;
    path?: never;
    query: {
        filename: string;
    };
    url: "/api/files";
};

export type DeleteFileErrors = {
    /**
     * Eroare tratata de GlobalExceptionHandler (400/401/403/404/409/429/500), cu corp uniform
     */
    default: ErrorResponse;
};

export type DeleteFileError = DeleteFileErrors[keyof DeleteFileErrors];

export type DeleteFileResponses = {
    /**
     * OK
     */
    200: unknown;
};
